webpackJsonp([4],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(23);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(101), __esModule: true };

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47);
__webpack_require__(27);
module.exports = __webpack_require__(102);


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var get = __webpack_require__(25);
module.exports = __webpack_require__(0).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function processSelectItem(container, menu, menuItem, seletedItem) {
  var flag = menuItem.getAttribute("data-flag");
  var code = menuItem.getAttribute("data-phone-code");
  seletedItem.querySelector(".selected--flag").innerHTML = "<img class=\"sprite_flags_" + flag.toLocaleLowerCase() + "\">";
  seletedItem.querySelector(".selected--code").textContent = code;
  container.parentNode.querySelector("input[name='enquiry[phone_country_code]']").setAttribute('value', flag.toLocaleUpperCase());
  container.querySelector('input.phone').focus();
  menu.classList.add("hide");
}

function handleMenuClick(container, menu, seletedItem) {
  menu.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var liTag = e.target.closest("li");
    processSelectItem(container, menu, liTag, seletedItem);
  });
}

function handleDropdownClick(dropdown, menu) {
  dropdown.addEventListener("click", function () {
    menu.classList.toggle("hide");
  });
}

function handleOutSideClick(dropdown) {
  document.body.addEventListener("click", function (e) {
    if (!dropdown.contains(e.target)) {
      var menu = dropdown.querySelector('ul');
      menu.classList.add("hide");
    }
  });
}

function initDropdownEvents(containers) {
  containers.forEach(function (container) {
    var dropdown = container.querySelector(".country-dropdown");
    var menu = dropdown.querySelector("ul");
    var selectedItem = dropdown.querySelector(".country-dropdown__seleted");

    handleDropdownClick(dropdown, menu);
    handleMenuClick(container, menu, selectedItem);
    handleOutSideClick(container);
  });
}

exports.default = initDropdownEvents;

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(106), __esModule: true };

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(107);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(30), 'Object', { defineProperties: __webpack_require__(151) });


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(109), __esModule: true };

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(110);
var $Object = __webpack_require__(0).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(126), __esModule: true };

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(148) });


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _popover = __webpack_require__(129);

var _popover2 = _interopRequireDefault(_popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function processPopovers() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  container.querySelectorAll("[data-popover]").forEach(function (popover) {
    _reactDom2.default.render(_react2.default.createElement(_popover2.default, popover.dataset), popover);
  });
}

exports.default = processPopovers;

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(36);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(37);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var autocomplete = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var params, url, results;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = query ? { q: query, token: SESSION_TOKEN } : undefined;
            url = getUrl.call(this, _constants.URLS.autocomplete, params);
            results = void 0;
            _context.prev = 3;
            _context.next = 6;
            return (0, _fetcher.json)(url, { warn: true });

          case 6:
            results = _context.sent;
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);

            results = {};

          case 12:

            dispatchResultsEvent(_constants.RESULTEVENT_TYPES.AUTOCOMPLETE, results);

            return _context.abrupt("return", results);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 9]]);
  }));

  return function autocomplete() {
    return _ref.apply(this, arguments);
  };
}();

var googlePlace = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(placeId) {
    var url, results;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = getUrl.call(this, _constants.URLS.googlePlace, { place_id: placeId, token: SESSION_TOKEN });
            results = void 0;
            _context2.prev = 2;
            _context2.next = 5;
            return (0, _fetcher.json)(url);

          case 5:
            results = _context2.sent;
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](2);

            results = { error: _context2.t0.message, url: _context2.t0.url };

          case 11:

            dispatchResultsEvent(_constants.RESULTEVENT_TYPES.GOOGLEPLACE, results);

            return _context2.abrupt("return", results);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[2, 8]]);
  }));

  return function googlePlace(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var search = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(params) {
    var url, results;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = getUrl.call(this, _constants.URLS.search, params);
            results = void 0;
            _context3.prev = 2;
            _context3.next = 5;
            return (0, _fetcher.json)(url);

          case 5:
            results = _context3.sent;
            _context3.next = 11;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](2);

            results = { error: _context3.t0.message };

          case 11:

            dispatchResultsEvent(_constants.RESULTEVENT_TYPES.SEARCH, results);

            return _context3.abrupt("return", results);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[2, 8]]);
  }));

  return function search(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var _constants = __webpack_require__(59);

var _session_tokens = __webpack_require__(134);

var _session_tokens2 = _interopRequireDefault(_session_tokens);

var _fetcher = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SESSION_TOKEN = (0, _session_tokens2.default)();

function dispatchResultsEvent(type, data) {
  var resultsEvent = new CustomEvent(type + "results", { detail: { data: data } });

  document.body.dispatchEvent(resultsEvent);
}

function getUrl(href, params) {
  var searchStr = new URLSearchParams(params).toString();

  return this + href + (searchStr.length ? "?" + searchStr : "");
}

function FrontendAPI() {
  var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.URLS.baseUrl;

  var self = this;

  self.autocomplete = autocomplete.bind(baseUrl);
  self.googlePlace = googlePlace.bind(baseUrl);
  self.search = search.bind(baseUrl);
}

exports.default = FrontendAPI;

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var API = "https://suite24.emarsys.net/u/register.php";
var FAIL_MESSAGE = "Oops! Something went wrong, please refresh the page and try again.";
var PARAMS = {
  CID: 785825047,
  p: 2,
  a: "r",
  SID: "",
  el: "",
  llid: "",
  counted: "",
  c: "",
  optin: "y"
};
var SUCCESS_MESSAGE = "Thank you for signing up!";

exports.API = API;
exports.FAIL_MESSAGE = FAIL_MESSAGE;
exports.PARAMS = PARAMS;
exports.SUCCESS_MESSAGE = SUCCESS_MESSAGE;

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fetcher = __webpack_require__(50);

var NOOP = function NOOP() {};
var SUBMIT_RECAPTCHA = "submitRecaptcha";

function executeRecaptcha() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$success = _ref.success,
      success = _ref$success === undefined ? NOOP : _ref$success,
      _ref$fail = _ref.fail,
      fail = _ref$fail === undefined ? NOOP : _ref$fail,
      _ref$always = _ref.always,
      always = _ref$always === undefined ? NOOP : _ref$always;

  var _window = window,
      grecaptcha = _window.grecaptcha;


  function submitRecaptcha() {
    var url = "/recaptcha?g-recaptcha-response=" + grecaptcha.getResponse();

    return (0, _fetcher.json)(url).then(function () {
      success();
      window[SUBMIT_RECAPTCHA] = null;
    }).catch(fail).finally(always);
  }

  if (grecaptcha && grecaptcha.execute) {
    window[SUBMIT_RECAPTCHA] = submitRecaptcha;

    grecaptcha.execute();
  }
}

exports.default = executeRecaptcha;

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(117);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ 117:
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperties = __webpack_require__(105);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _defineProperty = __webpack_require__(23);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _keys = __webpack_require__(4);

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-console */

var STRINGS = {
  finish: "Adding missing $type mark for `$src`, measure will be to window.onload"
};

/**
 * @private
 * Replaces placeholders in message string with values.
 *
 * @param {Object} arg
 * @param {String} arg.string - The message string to use
 * @param {String} arg.src - The source for the message string
 * @param {String} arg.type - The type for the message string
 *
 * @returns {String}
 */
function stringReplace(_ref) {
  var string = _ref.string,
      src = _ref.src,
      type = _ref.type;

  var source = STRINGS[string];

  return source ? source.replace("$src", src).replace("$type", type) : string;
}

/**
 * @private
 * Writes out to the console the grouped marks or measures that have been
 * created in the instance.
 *
 * @param {string} type - Type of entries to use ("marks" / "measures")
 */
function debugReport(type) {
  var self = this;
  var entries = self[type] || [];

  if (!entries.length) {
    console.error("No " + type + " found");
    return;
  }

  console.group(self.src + ": " + type);
  entries.forEach(function (entry) {
    var time = type === "marks" ? entry.startTime : entry.duration;

    console.info(entry.name + ": " + time + "ms");
  });
  console.groupEnd();
}

/**
 * @private
 * Gets the latest entry for the supplied source and type.
 *
 * @param {string} src The source
 * @param {string} type The type of entry to use
 */
function getLatestEntry(src, type) {
  return window.performance.getEntriesByType(type).reverse().find(function (entry) {
    return entry.name.substr(0, src.length) === src;
  });
}

/**
 * @private
 * Gets the prefix for marks and measures from the supplied source and optional method.
 *
 * @param {string} src - The source
 * @param {stirng=} method - Name of method (optional)
 */
function getPrefix(src, method) {
  return src + (method ? ":" + method : "");
}

/**
 * Processes a mark to find an associated finish mark and add a measure of them.
 *
 * Should a finish mark not be found, the `finish` method is run to add one.
 *
 * @private
 *
 * @param {PerformanceEntry} mark - Mark to process
 */
function processMark(mark) {
  var self = this;

  var _mark$split = mark.split("_"),
      _mark$split2 = (0, _slicedToArray3.default)(_mark$split, 1),
      method = _mark$split2[0];

  var markFinish = method + "_finish";

  if (!self.marks.find(function (_ref2) {
    var name = _ref2.name;
    return name.endsWith(markFinish);
  })) {
    console.warn(stringReplace({ string: STRINGS.finish, src: method, type: "finish" }));

    self.finish(method);
  }

  self.measure(method);
}

/**
 * Verifies that each start mark for methods has a matching finish mark
 *
 * @private
 */
function checkMarks() {
  var self = this;

  self.marks.filter(function (_ref3) {
    var name = _ref3.name;
    return name.endsWith("_start");
  }).map(function (entry) {
    return entry.name.split(":")[1];
  }).forEach(processMark.bind(self));
}

function onload() {
  var self = this;
  var src = self.src;

  var finishMark = window.performance.getEntriesByType("mark").find(function (entry) {
    return entry.name === src + "_complete";
  });

  if (!finishMark) {
    console.warn(stringReplace({ string: STRINGS.finish, src: src, type: "complete" }));
    self.finish();
  }

  self.measure();
  checkMarks.call(self);
}

var API = {
  /**
   * Adds a mark to denote the finish of method timing.
   *
   * Should `method` be omitted, default behaviour is to set a mark for the
   * finish of the _source_ timing.
   *
   * @param {string=} method - Name of method that is being timed (optional)
   */
  finish: function finish(method) {
    var self = this;
    var src = self.src;

    var prefix = getPrefix(src, method);
    var name = prefix + "_" + (method ? "finish" : "complete");

    window.performance.mark(name);
    self.marks = self.marks || [];
    self.marks.push(getLatestEntry.call(self, src, "mark"));
  },

  /**
   * Adds a measure denoting the duration of a supplied method.
   *
   * Should `method` be omitted, default behaviour is to set a measure for the _source_.
   *
   * @param {string=} method - Name of method that is being measured (optional)
   */
  measure: function measure(method) {
    var self = this;
    var src = self.src;

    var name = getPrefix(src, method);
    var startName = name + "_" + (method ? "start" : "init");
    var finishName = name + "_" + (method ? "finish" : "complete");

    window.performance.measure(name, startName, finishName);
    self.measures = self.measures || [];
    self.measures.push(getLatestEntry.call(self, src, "measure"));
  },

  /**
   * Runs an optionally supplied function to create a report of marks or measures.
   *
   * Should a `type` value not be specified, a default of `"measures"` is used.
   * Should a function reference not be specified, the debugging will automatically occur.
   *
   * @param {Object=} arg
   * @param {Function=} arg.fn - The function to run (optional)
   * @param {String=} arg.type - The type of entry to report on (optional)
   * @param {Boolean=} arg.debug - Flag denoting if debug information should be written
   *                               into the console (optional)
   */
  report: function report() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        fn = _ref4.fn,
        _ref4$type = _ref4.type,
        type = _ref4$type === undefined ? "measures" : _ref4$type,
        _ref4$debug = _ref4.debug,
        debug = _ref4$debug === undefined ? !fn : _ref4$debug;

    var self = this;

    if (fn) {
      fn(self[type]);
    }

    if (debug) {
      self.debug(type);
    }
  },

  /**
   * Adds a mark to denote the start of method timing.
   *
   * Should `method` be omitted, default behaviour is to set a mark for the start
   * of the _source_ timing.
   *
   * @param {String=} method - Name of method that is being timed (optional)
   */
  start: function start(method) {
    var self = this;
    var src = self.src;

    var prefix = getPrefix(src, method);
    var name = prefix + "_" + (method ? "start" : "init");

    window.performance.mark(name);
    self.marks = self.marks || [];
    self.marks.push(getLatestEntry.call(self, src, "mark"));
  }
};

/**
 * When initialised, an event listener is added to the onload event of `window`
 * and a performance mark is immediately added to set the time of initialisation.
 *
 * Should a `src` value not be specified, a default of`"undefined source"` is used.
 *
 * @param {String=} src - Name of source file / base object (optional)
 */
function UserTiming(_ref5) {
  var src = _ref5.src;

  var self = this;

  self.src = src || "undefined source";

  if (src) {
    window.addEventListener("load", onload.bind(self));
  }

  self.start();
}

var proto = UserTiming.prototype;


(0, _keys2.default)(API).forEach(function (key) {
  (0, _defineProperty2.default)(proto, key, {
    enumerable: true,
    value: API[key]
  });
});

(0, _defineProperties2.default)(proto, {
  debug: {
    value: debugReport
  }
});

exports.default = UserTiming;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function initAutocompleteToggle() {
  var searchButton = document.getElementById("js-search-button");
  var autocomplete = document.querySelector("header [data-component=autocomplete-block]");

  if (searchButton && autocomplete) {
    searchButton.addEventListener("click", function () {
      autocomplete.toggleAttribute("open");
    });
  }
}

exports.default = initAutocompleteToggle;

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(88);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(53);

var _from2 = _interopRequireDefault(_from);

var _keys = __webpack_require__(4);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var breakpoints = {
  maxres: "1025px",
  sd: "769px",
  hq: "481px"
};

function makeIframe(id) {
  var src = "https://www.youtube-nocookie.com/embed/" + id + "?autoplay=1&rel=0";
  var iframe = document.createElement("iframe");

  iframe.setAttribute("allowfullscreen", "");
  iframe.setAttribute("frameborder", 0);
  iframe.setAttribute("allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture");
  iframe.src = src;
  iframe.width = 600;
  iframe.height = 337;

  return iframe;
}

function swapInIframe(e) {
  var target = e.target;

  var iframe = makeIframe(target.dataset.id);

  target.parentNode.replaceChild(iframe, target);
}

function makePlayButton(id) {
  var div = document.createElement("div");

  div.classList.add("video__play");
  div.dataset.id = id;
  div.addEventListener("click", swapInIframe);

  return div;
}

function makeThumbnailImage(id, title) {
  var imageUrlBase = "https://i.ytimg.com/vi/" + id;
  var picture = document.createElement("picture");

  (0, _keys2.default)(breakpoints).forEach(function (key) {
    var source = document.createElement("source");

    source.media = "(min-width: " + breakpoints[key] + ")";
    source.srcset = imageUrlBase + "/" + key + "default.jpg";

    picture.appendChild(source);
  });

  var image = document.createElement("img");

  image.alt = title;
  image.src = imageUrlBase + "/mqdefault.jpg";

  picture.appendChild(image);

  return picture;
}

function addChildElements(video) {
  var _video$dataset = video.dataset,
      id = _video$dataset.id,
      title = _video$dataset.title;


  if (!video.id) {
    video.id = "video_" + id;
  }

  if (location.hash.endsWith(id)) {
    video.scrollIntoView();
  }

  video.appendChild(makeThumbnailImage(id, title));
  video.appendChild(makePlayButton(id));
}

function embedYoutube() {
  (0, _from2.default)(document.querySelectorAll(".js-video[data-id]")).forEach(function (video) {
    addChildElements(video);
    video.classList.remove("js-video");
    delete video.dataset.id;
  });
}

exports.default = embedYoutube;

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Enquiries = __webpack_require__(20);

var _DatePickerSupport = __webpack_require__(82);

var ENQUIRY_SELECTOR = "#js-general-enquiry";

exports.default = function () {
  (0, _Enquiries.initEnquiry)(document.querySelector(ENQUIRY_SELECTOR));

  $(ENQUIRY_SELECTOR + " .js-arrival-date").pickadate((0, _DatePickerSupport.regularPickerOptions)()).pickadate("picker");
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIN_SELECTORS = undefined;

var _keys = __webpack_require__(4);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BREAKPOINTS = {
  smallPalm: 480,
  mobile: 600,
  handheld: 800,
  portable: 1024
};

var MIN_SELECTORS = (0, _keys2.default)(BREAKPOINTS).reduce(function (obj, key) {
  var value = BREAKPOINTS[key] + 1;
  obj[key] = "(min-width: " + value + "px)";

  return obj;
}, {});

exports.default = BREAKPOINTS;
exports.MIN_SELECTORS = MIN_SELECTORS;

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gtm_tracking = __webpack_require__(5);

var _Enquiries = __webpack_require__(20);

var _Forms = __webpack_require__(26);

var _Forms2 = _interopRequireDefault(_Forms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleClick = function handleClick(enquiry, buttonSelector) {
  return function (e) {
    var button = e.target.closest(buttonSelector);

    if (button) {
      e.preventDefault();
      var slug = window.location.pathname.split("/")[1];
      var _button$dataset = button.dataset,
          enquiryTitle = _button$dataset.enquiryTitle,
          enquiryPrice = _button$dataset.enquiryPrice,
          enquiryNights = _button$dataset.enquiryNights,
          enquiryDate = _button$dataset.enquiryDate,
          enquirySubtitle = _button$dataset.enquirySubtitle,
          enquiryButton = _button$dataset.enquiryButton,
          enquiryAdditionalInfo = _button$dataset.enquiryAdditionalInfo,
          enquiryCallUs = _button$dataset.enquiryCallUs,
          enquiryShowCountryDropdown = _button$dataset.enquiryShowCountryDropdown;


      (0, _Enquiries.setTitle)(enquiry, enquiryTitle);
      (0, _Enquiries.setSubtitle)(enquiry, { nights: enquiryNights, date: enquiryDate, override: enquirySubtitle });
      (0, _Enquiries.setButtonText)(enquiry, enquiryButton);
      (0, _Enquiries.setAdditionalInfoPlaceholder)(enquiry, enquiryAdditionalInfo);
      (0, _Enquiries.setCallUsText)(enquiry, enquiryCallUs);
      (0, _Enquiries.setCountryDropdownVisibility)(enquiry, enquiryShowCountryDropdown);

      enquiry.querySelector(".js-enquiry-subject").value = enquiryTitle;
      enquiry.querySelector(".js-enquiry-price").style.display = enquiryPrice ? "block" : "none";

      $("#js-named-enquiry-modal").modal("show");

      if (enquiryPrice) {
        enquiry.querySelector(".js-enquiry-price .price").textContent = "\xA3" + enquiryPrice;

        (0, _gtm_tracking.dynamicRemarketing)({
          hrental_id: slug,
          hrental_totalvalue: parseInt(enquiryPrice, 10),
          hrental_pagetype: "conversionintent"
        });
      }

      (0, _gtm_tracking.virtualPageView)("PERSONAL_DETAILS");
    }
  };
};

var initNamedEnquiry = function initNamedEnquiry() {
  var enquiry = document.querySelector("#js-named-enquiry");
  var form = enquiry.querySelector(".js-enquiry-form");

  (0, _Enquiries.resetModal)(enquiry);

  (0, _Forms2.default)(form, { submit: (0, _Enquiries.handleSubmit)(enquiry) });

  document.body.addEventListener("click", handleClick(enquiry, ".js-named-enquiry-button"));

  (0, _Enquiries.formFieldFocusHandler)(enquiry);

  (0, _Enquiries.addInvalidSubmitHandler)(form);

  (0, _Enquiries.initLoadCountryPhone)(enquiry);
};

exports.default = initNamedEnquiry;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _newsletter = __webpack_require__(125);

var _newsletter2 = _interopRequireDefault(_newsletter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function newsletter() {
  var container = document.getElementById("js-newsletter-form");

  if (container) {
    _reactDom2.default.render(_react2.default.createElement(_newsletter2.default, null), container);
  }
}

exports.default = newsletter;

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(11);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsCookie = __webpack_require__(17);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Emarsys = __webpack_require__(87);

var _Emarsys2 = _interopRequireDefault(_Emarsys);

var _gtm_tracking = __webpack_require__(5);

var _ga4_helper = __webpack_require__(56);

var _newsletterModule = __webpack_require__(128);

var _newsletterModule2 = _interopRequireDefault(_newsletterModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NEWSLETTER_CAMPAIGN_ID = "1259";
var NEWSLETTER_COOKIE = "hide_newsletter_signup";
var NEWSLETTER_POPOVER_COOKIE = "hide_newsletter_tip";

function loadReCaptcha() {
  var script = document.createElement("script");

  script.async = true;
  script.src = "https://www.google.com/recaptcha/api.js";
  document.head.appendChild(script);
}

var Newsletter = function (_React$Component) {
  (0, _inherits3.default)(Newsletter, _React$Component);

  function Newsletter(props) {
    (0, _classCallCheck3.default)(this, Newsletter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Newsletter.__proto__ || (0, _getPrototypeOf2.default)(Newsletter)).call(this, props));

    _this.setFailedState = function () {
      _this.setState({ failed: true, submitting: false });
    };

    _this.setSucceededState = function () {
      _this.setState({ succeeded: true, submitting: false, visible: false });
      _this.toggleReCaptcha(false);
      (0, _gtm_tracking.gaEventNoHit)("Goals", "Newsletter", "Success");
      (0, _ga4_helper.pushGa4Event)({
        event: "generate_lead",
        lead_type: "Newsletter Signup"
      });
      _this.setCookies();
      _this.hidePopover();
    };

    _this.initForm = function () {
      (0, _Emarsys2.default)(_this.form, {
        submit: function submit() {
          _this.setState({ failed: false, submitting: true });
        }
      }, { success: _this.setSucceededState, fail: _this.setFailedState });
    };

    _this.showForm = function () {
      var recaptchad = _this.state.recaptchad;


      if (!recaptchad) {
        loadReCaptcha();
        _this.setState({ recaptchad: true });
      }

      _this.setState({ visible: true }, _this.initForm);
      _this.toggleReCaptcha(true);
      (0, _gtm_tracking.gaEventNoHit)("Goals", "Newsletter", "Open Form");
    };

    _this.state = {
      recaptchad: false,
      visible: props.modal || false,
      submitting: false,
      succeeded: false,
      failed: false
    };
    return _this;
  }

  (0, _createClass3.default)(Newsletter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.visible) {
        this.initForm();
      }
    }
  }, {
    key: "setCookies",
    value: function setCookies() {
      [NEWSLETTER_COOKIE, NEWSLETTER_POPOVER_COOKIE].forEach(function (cookie) {
        _jsCookie2.default.set(cookie, "true", { expires: 20 * 365, samesite: "lax" });
      });
    }
  }, {
    key: "hidePopover",
    value: function hidePopover() {
      var popover = document.querySelector("[data-popover][data-cookie=" + NEWSLETTER_POPOVER_COOKIE + "]");

      if (popover) {
        popover.classList.add("hide");
      }
    }
  }, {
    key: "toggleReCaptcha",
    value: function toggleReCaptcha(show) {
      var recaptcha = document.querySelector('.g-recaptcha');

      if (!recaptcha) {
        return;
      }

      var chatButtons = document.getElementById("js-chat-buttons");
      var method = show ? 'add' : 'remove';

      if (chatButtons) {
        chatButtons.classList[method]("hide");
      }

      recaptcha.classList[method]('show');
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      var _this2 = this;

      return _react2.default.createElement(
        "form",
        {
          className: _newsletterModule2.default.form,
          ref: function ref(_ref) {
            _this2.form = _ref;
          },
          autoComplete: "on",
          "data-emarsys-form": true,
          "data-campaign-id": NEWSLETTER_CAMPAIGN_ID
        },
        _react2.default.createElement(
          "div",
          { className: "form-group form-control__placeholder-label" },
          _react2.default.createElement(
            "label",
            { htmlFor: "inp_1" },
            "First name"
          ),
          _react2.default.createElement("input", {
            type: "text",
            name: "inp_1",
            id: "inp_1",
            placeholder: "First name",
            className: "form-control form-control--custom js-floating-placeholder",
            maxLength: "50",
            autoComplete: "given-name",
            required: true
          })
        ),
        _react2.default.createElement(
          "div",
          { className: "form-group form-control__placeholder-label" },
          _react2.default.createElement(
            "label",
            { htmlFor: "inp_2" },
            "Last name"
          ),
          _react2.default.createElement("input", {
            type: "text",
            name: "inp_2",
            id: "inp_2",
            placeholder: "Last name",
            className: "form-control form-control--custom js-floating-placeholder",
            maxLength: "50",
            autoComplete: "family-name",
            required: true
          })
        ),
        _react2.default.createElement(
          "div",
          { className: "form-group form-control__placeholder-label" },
          _react2.default.createElement(
            "label",
            { htmlFor: "inp_3" },
            "Email"
          ),
          _react2.default.createElement("input", {
            type: "email",
            name: "inp_3",
            id: "inp_3",
            placeholder: "Email",
            className: "form-control form-control--custom js-trim-email js-floating-placeholder",
            maxLength: "254",
            autoComplete: "email",
            required: true
          })
        ),
        _react2.default.createElement(
          "div",
          { className: "form-group" },
          _react2.default.createElement(
            "button",
            {
              type: "submit",
              className: "btn btn-lg button--alt--solid gtm-track-click",
              "data-gtm-category": "All Pages",
              "data-gtm-action": "Newsletter",
              "data-gtm-label": "Clicked Submit",
              disabled: this.state.submitting
            },
            "Get the latest deals"
          )
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      if (_jsCookie2.default.get(NEWSLETTER_COOKIE)) {
        return null;
      }

      var wrapper = _newsletterModule2.default.wrapper,
          container = _newsletterModule2.default.container,
          icon = _newsletterModule2.default.icon,
          content = _newsletterModule2.default.content,
          heading = _newsletterModule2.default.heading,
          cta = _newsletterModule2.default.cta;
      var modal = this.props.modal;
      var _state = this.state,
          failed = _state.failed,
          succeeded = _state.succeeded,
          visible = _state.visible;


      return _react2.default.createElement(
        "div",
        { className: wrapper },
        _react2.default.createElement(
          "div",
          { className: container },
          _react2.default.createElement(
            "div",
            { className: icon },
            _react2.default.createElement("i", { className: "fa fa-2x fa-fw fa-envelope-o" })
          ),
          _react2.default.createElement(
            "div",
            { className: content },
            modal && !succeeded && _react2.default.createElement(
              "div",
              { className: "h3" },
              "Join today & get great golf holiday deals!"
            ),
            visible && this.renderForm(),
            succeeded && _react2.default.createElement(
              "div",
              { className: heading },
              "Thanks, your deals are on their way!"
            ),
            failed && _react2.default.createElement(
              "div",
              null,
              "Oops! Something went wrong, would you mind trying again?"
            ),
            !modal && !visible && !succeeded && _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "div",
                { className: heading },
                "Never miss a deal!"
              ),
              _react2.default.createElement(
                "div",
                null,
                "Sign up to receive our newsletter"
              )
            )
          ),
          !visible && !succeeded && _react2.default.createElement(
            "div",
            { className: cta },
            _react2.default.createElement(
              "button",
              {
                className: "btn btn-lg button--alt--solid gtm-track-click",
                "data-gtm-category": "All Pages",
                "data-gtm-action": "Newsletter",
                "data-gtm-label": "Clicked Sign Up",
                type: "button",
                onClick: this.showForm
              },
              "Sign up"
            )
          )
        ),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "a",
            { href: "/privacy" },
            _react2.default.createElement(
              "small",
              null,
              "Learn more about how YourGolfTravel collects and uses personal data."
            )
          )
        )
      );
    }
  }]);
  return Newsletter;
}(_react2.default.Component);

exports.default = Newsletter;

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(127);
module.exports = __webpack_require__(0).Object.getPrototypeOf;


/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(28);
var $getPrototypeOf = __webpack_require__(156);

__webpack_require__(54)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ 128:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1eRcaakXGjSRZKd_Tx5mib","container":"_3QwG04H14bqa00XjbCOaML","icon":"MxZfSWffPQc4wclvesIgD","content":"_2-xfTJM5s-TwVBTwTGeFS7","form":"_1OEFJQT3_cTXaVqtsVX9Xn","heading":"HmM8YU-svbjTmidW3b5Dh","cta":"_3IEDLAC80ARP6jir5w4sL9"};

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(11);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsCookie = __webpack_require__(17);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(58);

var _classnames2 = _interopRequireDefault(_classnames);

var _popoverModule = __webpack_require__(130);

var _popoverModule2 = _interopRequireDefault(_popoverModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Popover = function (_React$Component) {
  (0, _inherits3.default)(Popover, _React$Component);

  function Popover() {
    (0, _classCallCheck3.default)(this, Popover);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this));

    _this.close = function () {
      _this.setState({ visible: false });
      _jsCookie2.default.set(_this.props.cookie, "true", {
        expires: 20 * 365,
        samesite: "lax"
      });
    };

    _this.state = { visible: true };
    return _this;
  }

  (0, _createClass3.default)(Popover, [{
    key: "render",
    value: function render() {
      if (_jsCookie2.default.get(this.props.cookie) || !this.state.visible) {
        return null;
      }

      var container = _popoverModule2.default.container,
          close = _popoverModule2.default.close;
      var _props = this.props,
          content = _props.content,
          color = _props.color,
          position = _props.position;

      var classNames = (0, _classnames2.default)(container, color && _popoverModule2.default[color], position && _popoverModule2.default[position]);

      return _react2.default.createElement(
        "div",
        { className: classNames },
        content,
        _react2.default.createElement(
          "button",
          { type: "button", className: close, onClick: this.close },
          _react2.default.createElement("i", { className: "fa fa-close" })
        )
      );
    }
  }]);
  return Popover;
}(_react2.default.Component);

exports.default = Popover;

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(78);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(108);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(88);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bottom-right":"KlgkkWnhRJ8Jn4_hPJhMz","fadeInUp":"_2G9JzgaQJAjBh00jva6NkW","bottom-center":"_3vLqlGXgGu9bHylsqkoBOp","fadeInUpCenter":"_1pGv7VnFL7Lv4cVuUDZPiQ","container":"_3CQd3JOz_a68IYqh94zzmo","blue":"_1v5La6BazQJano2rb_Ii3S","close":"_3MrnJsakIZVRonereXTxXj","pulsate":"_2VkMH_7hgaK5HRnVRTThAv"};

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _deferPicture = __webpack_require__(60);

var ATTRIBUTE = "data-responsive";

function onafterload(e) {
  var src = e.detail.src;

  var target = src.closest("[" + ATTRIBUTE + "]");

  if (target) {
    if ('error' in src.dataset) {
      target.dataset.error = "";
    } else {
      target.style.backgroundImage = "url(\"" + src.currentSrc + "\")";
    }
  }
}

function init() {
  window.addEventListener(_deferPicture.AFTER_LOAD_EVENT, onafterload);
}

document.addEventListener("DOMContentLoaded", init);

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(4);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NOOP = function NOOP() {};
var DEFAULTS = { async: true, data: {}, id: null, onload: NOOP, preload: NOOP, src: null };
var scripts = [];

function maker(_ref) {
  var async = _ref.async,
      data = _ref.data,
      id = _ref.id,
      onload = _ref.onload,
      src = _ref.src;

  var script = document.createElement("script");

  script.async = async;
  (0, _keys2.default)(data).forEach(function (datum) {
    script.dataset[datum] = data[datum];
  });

  if (id) {
    script.id = id;
  }

  script.addEventListener("load", onload);

  document.head.appendChild(script);
  script.src = src;
}

function ongtmscriptrequest(_ref2) {
  var detail = _ref2.detail;

  var options = (0, _assign2.default)(DEFAULTS, detail || {});
  var src = options.src;


  options.onload = options.onload.bind(window); // set onload context to window
  options.preload.call(window); // run preload in window context

  // if there is no source or it has already been requested, immediately run onload
  if (!src || scripts.includes(src)) {
    options.onload();
  } else {
    scripts.push(src);
    maker(options);
  }
}

window.addEventListener("gtmscriptrequest", ongtmscriptrequest);

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {

var _regenerator = __webpack_require__(36);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(37);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var onprefetch = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(input, e) {
    var target, _ref2, boundingBox, error, address, href, dataset;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            target = e.target;


            target.removeEventListener("click", target.prefetch);
            delete target.prefetch;

            _context.next = 6;
            return API.googlePlace(this);

          case 6:
            _ref2 = _context.sent;
            boundingBox = _ref2.bounding_box_url;
            error = _ref2.error;
            address = _ref2.formatted_address;


            if (!error) {
              href = "/place/" + encodeURIComponent(address) + "/" + encodeURIComponent(boundingBox);
              dataset = target.dataset;


              dataset.gtmCategory = getCategory(input);
              target.href = href;
              target.dispatchEvent(new MouseEvent("click")); // re-click link
            }

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function onprefetch(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var oninputinput = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
    var input, value, _ref5, _ref5$results, results, _ref5$total, total, _input$dataset2, initial, list, datalist, details;

    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            input = e.target;
            value = input.value;

            if (!(value.length > MINLENGTH)) {
              _context2.next = 8;
              break;
            }

            _context2.next = 5;
            return API.autocomplete(value);

          case 5:
            _context2.t0 = _context2.sent;
            _context2.next = 9;
            break;

          case 8:
            _context2.t0 = {};

          case 9:
            _ref5 = _context2.t0;
            _ref5$results = _ref5.results;
            results = _ref5$results === undefined ? [] : _ref5$results;
            _ref5$total = _ref5.total;
            total = _ref5$total === undefined ? 0 : _ref5$total;
            _input$dataset2 = input.dataset, initial = _input$dataset2.initial, list = _input$dataset2.list;


            if (list && list !== initial) {
              datalist = document.getElementById(list);


              datalist.parentNode.removeChild(datalist);
            }

            input.dataset.list = total ? "autocomplete-" + Math.random().toString(36).substr(2) : initial;
            fillList(input, results);
            fillDetails(input);

            details = getDetails(input);


            if (!details.open) {
              input.dispatchEvent(new MouseEvent("click"));
            }

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function oninputinput(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

var _lodash = __webpack_require__(86);

var _lodash2 = _interopRequireDefault(_lodash);

var _mutations = __webpack_require__(51);

var _mutations2 = _interopRequireDefault(_mutations);

var _search = __webpack_require__(113);

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = new _search2.default();
var DEBOUNCE_TIMEOUT = 250;
var ICONS = {
  "google-place": "map-marker",
  region: "map-marker",
  tour: "map-o",
  tournament: "trophy",
  venue: "flag"
};
var KEYCODES = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  UP: 38,
  DOWN: 40
};
var MINLENGTH = 2;
var SELECTOR = "[data-component^=autocomplete-]:not([data-enhanced])";
var TRANS = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

var NEW_ICON = document.createElement("i");

NEW_ICON.classList.add("fa");
NEW_ICON.setAttribute("aria-hidden", "true");

var NEW_IMAGE = document.createElement("img");

NEW_IMAGE.src = TRANS;
NEW_IMAGE.setAttribute("aria-hidden", "true");
NEW_IMAGE.setAttribute("height", "1");
NEW_IMAGE.setAttribute("width", "1");

var NEW_LINK = document.createElement("a");

NEW_LINK.classList.add("gtm-track-click");
NEW_LINK.href = "#";

function getCategory(input) {
  var isHomePage = location.path === "/";
  var inHeader = !!input.closest("header");
  var place = inHeader ? "Header" : "Body";

  if (isHomePage && !inHeader) {
    place = "Home page";
  }

  return "Autocomplete - " + place + " search";
}

function addResult(input, option) {
  var _option$dataset = option.dataset,
      cc = _option$dataset.cc,
      prefetch = _option$dataset.prefetch,
      type = _option$dataset.type,
      value = _option$dataset.value;
  var textContent = option.textContent;

  var a = NEW_LINK.cloneNode();
  var dataset = a.dataset;


  if (prefetch) {
    a.prefetch = onprefetch.bind(value, input);
    a.addEventListener("click", a.prefetch);
  } else {
    a.href = value;

    // due to the "global" click event handler, we don't want GTMCategory on prefetch links
    // otherwise we get an extra entry in window.dataLayer from `trackClick`
    dataset.gtmCategory = getCategory(input);
  }

  dataset.gtmAction = textContent;

  if (type === "region" && cc) {
    var img = NEW_IMAGE.cloneNode();

    img.alt = "Flag of " + textContent;
    img.classList.add("sprite_flags_" + cc);

    a.appendChild(img);
  } else {
    var icon = NEW_ICON.cloneNode();

    icon.classList.add("fa-" + ICONS[type]);

    a.appendChild(icon);
  }

  a.appendChild(document.createTextNode(textContent));
  var li = document.createElement("li");

  li.appendChild(a);
  this.appendChild(li);
}

function getDetails(target) {
  return target.closest("section").querySelector("details");
}

function fillDetails(input) {
  var list = input.dataset.list;

  var datalist = document.getElementById(list);
  var details = getDetails(input);
  var lastChild = details.lastChild;


  if (lastChild.nodeName === "UL") {
    details.removeChild(lastChild);
  }

  if (datalist) {
    var ul = document.createElement("ul");
    var fragment = document.createDocumentFragment();

    datalist.querySelectorAll("option").forEach(addResult.bind(fragment, input));
    ul.appendChild(fragment);

    details.appendChild(ul);
  } else {
    // eslint-disable-next-line
    console.warn("Unable to find autocomplete list #" + list);
  }
}

function fillItem(_ref3) {
  var countryCode = _ref3.countryCode,
      name = _ref3.name,
      reference = _ref3.reference,
      slug = _ref3.slug,
      type = _ref3.type;

  var option = document.createElement("option");
  var dataset = option.dataset;


  if (countryCode) {
    dataset.cc = countryCode;
  }

  dataset.type = type;
  if (type === "google-place") {
    dataset.value = reference;
    dataset.prefetch = "googlePlace";
  } else {
    dataset.value = "/" + slug;
  }

  option.textContent = name;

  this.appendChild(option);
}

function fillList(input, results) {
  var _input$dataset = input.dataset,
      initial = _input$dataset.initial,
      list = _input$dataset.list;


  if (list && list !== initial) {
    var fragment = document.createDocumentFragment();

    results.forEach(fillItem.bind(fragment));

    var datalist = document.createElement("datalist");

    datalist.id = list;
    datalist.appendChild(fragment);

    var initialList = document.getElementById(initial) || document.body.lastChild;

    initialList.parentNode.appendChild(datalist);
  }
}

function onclick(e) {
  var details = getDetails(e.target);
  var fn = details.open ? "removeAttribute" : "setAttribute";

  details[fn]("open", "");
}

function ondetailsclick(e) {
  var target = e.target;


  if (target.prefetch) {
    e.preventDefault();
  }

  target.dataset.gtmLabel = this.value;
}

function ondetailskeydown(e) {
  var keyCode = e.keyCode;
  var target = e.target;


  if (keyCode !== KEYCODES.ENTER) {
    e.preventDefault();

    var input = this;
    var _target$parentNode = target.parentNode,
        nextSibling = _target$parentNode.nextSibling,
        previousSibling = _target$parentNode.previousSibling;


    if (keyCode === KEYCODES.TAB && !nextSibling || keyCode === KEYCODES.ESC) {
      input.dispatchEvent(new MouseEvent("click"));

      return;
    }

    if (keyCode === KEYCODES.DOWN) {
      // next entry or wrap round to first
      target = (nextSibling || target.closest("ul")).querySelector("a");
    }

    if (keyCode === KEYCODES.UP) {
      // previous entry or jump up to input
      target = previousSibling ? previousSibling.querySelector("a") : input;
    }

    target.focus();
  }
}

function ondocumentclick(e) {
  var self = this;

  if (!self.contains(e.target)) {
    getDetails(self).removeAttribute("open");
  }
}

function oninputkeydown(e) {
  var altKey = e.altKey,
      keyCode = e.keyCode,
      shiftKey = e.shiftKey,
      target = e.target;

  var details = getDetails(target);
  var open = details.open;

  var enter = keyCode === KEYCODES.ENTER;
  var tab = keyCode === KEYCODES.TAB;
  var down = tab && altKey || keyCode === KEYCODES.DOWN;
  var up = tab && shiftKey || keyCode === KEYCODES.UP || keyCode === KEYCODES.ESC;
  var toggle = open ? up : down;

  if (toggle) {
    target.dispatchEvent(new MouseEvent("click"));
  }

  if (down && open) {
    e.preventDefault();

    details.querySelector("a").focus();
  }

  if (enter && open) {
    if (target.dataset.initial !== target.dataset.list) {
      getDetails(target).querySelector('a').dispatchEvent(new MouseEvent("click"));
    }
  }
}

function processAutocomplete(autocomplete) {
  var input = autocomplete.querySelector("[type=search]");
  var list = input.getAttribute("list");

  if (list) {
    var dataset = input.dataset;


    dataset.initial = list; // save initial list ref
    dataset.list = dataset.initial; // "working" list
    input.removeAttribute("list"); // suppress built-in autocomplete
  }

  var details = document.createElement("details");

  details.appendChild(document.createElement("summary"));
  input.closest("form").appendChild(details);

  fillDetails(input);

  input.addEventListener("click", onclick);
  input.addEventListener("input", (0, _lodash2.default)(oninputinput, DEBOUNCE_TIMEOUT));
  input.addEventListener("keydown", oninputkeydown);
  input.form.addEventListener("submit", function (e) {
    return e.preventDefault();
  });

  details.addEventListener("click", ondetailsclick.bind(input));
  details.addEventListener("keydown", ondetailskeydown.bind(input));

  document.addEventListener("click", ondocumentclick.bind(input.form));

  autocomplete.dataset.enhanced = "";
}

function init() {
  document.querySelectorAll(SELECTOR).forEach(processAutocomplete);
}

document.addEventListener("DOMContentLoaded", init);

_mutations2.default.add(SELECTOR, processAutocomplete);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function generateSessionToken() {
  var d = Date.now();
  var r = void 0;

  return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/x/g, function () {
    r = Math.floor(d + Math.random() * 16) % 16;

    if (d) {
      d = Math.floor(d / 16);
    }

    return r.toString(16);
  });
}

exports.default = generateSessionToken;

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NAV_SELECTOR = "[data-scrollspy]";

var links = [];
var targets = [];
var observer = void 0;

function mapTarget(link) {
  if (links.includes(link)) {
    return null;
  }

  var container = this;
  var target = document.querySelector(link.getAttribute("href"));

  if (target) {
    links.push({
      closest: container.contains(link) ? container : null,
      left: link.getBoundingClientRect().left,
      parentNode: link.parentNode
    });
    targets.push(target);
  }

  return target;
}

function onIntersectionEntry(_ref) {
  var isIntersecting = _ref.isIntersecting,
      target = _ref.target;
  var _links$targets$indexO = links[targets.indexOf(target)],
      closest = _links$targets$indexO.closest,
      left = _links$targets$indexO.left,
      parentNode = _links$targets$indexO.parentNode;


  if (isIntersecting) {
    parentNode.classList.add("active");
    if (closest) {
      closest.scrollLeft += left;
    }
  } else {
    parentNode.classList.remove("active");
  }
}

function onIntersection(entries) {
  entries.forEach(onIntersectionEntry);
}

function observeTarget(link, target) {
  if (!target) {
    return;
  }

  observer = observer || new IntersectionObserver(onIntersection.bind(link), {
    root: null,
    rootMargin: "-10px 0px -90% 0px",
    threshold: 0
  });

  observer.observe(target);
}

function scrollSpy() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.querySelector(NAV_SELECTOR);

  if (!container) {
    return;
  }

  // container.querySelectorAll("a").forEach(observeTargetOld);
  container.querySelectorAll("a").forEach(function (link) {
    var target = mapTarget.call(container, link);

    observeTarget(link, target);
  });
}

exports.default = scrollSpy;

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.venueLink = exports.handleClick = undefined;

var _DateFormatConsts = __webpack_require__(52);

var _gtm_tracking = __webpack_require__(5);

var arrivalDataQueryParam = function arrivalDataQueryParam(arrivalDate) {
  return arrivalDate ? "&arrival_date=" + arrivalDate.format(_DateFormatConsts.ISO_DATE_FORMAT) : "";
};

var handleClick = function handleClick(action, label) {
  return function (e) {
    (0, _gtm_tracking.gaEvent)("Search Page", "Package: " + action, label);
    (0, _gtm_tracking.trackGoal)("CLICKED_PACKAGE");

    var target = e.target;

    var link = target.closest("[href]") || target.closest("[data-href]");

    if (link && !link.href) {
      window.location.href = link.dataset.href;
    }
  };
};

var venueLink = function venueLink(props) {
  return props.lmd ? "/" + props.venueUrl : "/" + props.venueUrl + "?package=" + props.id + arrivalDataQueryParam(props.arrivalDate);
};

exports.handleClick = handleClick;
exports.venueLink = venueLink;

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(94), __esModule: true };

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = lazyLoadMap;
function onIntersection(onLoad) {
  return function (entries, observer) {
    var firstIntersection = entries.find(function (entry) {
      return entry.isIntersecting;
    });

    if (!firstIntersection) {
      return;
    }

    var googleMaps = document.querySelector("script[data-google-maps]");

    if (!googleMaps) {
      return;
    }

    googleMaps.src = googleMaps.dataset.src;
    ["src", "googleMaps"].forEach(function (attr) {
      delete googleMaps.dataset[attr];
    });

    if (onLoad) {
      googleMaps.addEventListener("load", onLoad);
    }

    observer.unobserve(firstIntersection.target);
  };
}

function lazyLoadMap(onLoad) {
  var map = document.querySelector("[data-google-map]");

  if (!map) {
    return;
  }

  var onintersection = onIntersection(onLoad);
  var intersectionObserver = new IntersectionObserver(onintersection, {
    root: null,
    rootMargin: "200px 0px",
    threshold: 0
  });

  intersectionObserver.observe(map);
}

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _PackageFooter = __webpack_require__(164);

var _PackageFooter2 = _interopRequireDefault(_PackageFooter);

var _PackageHeader = __webpack_require__(165);

var _PackageHeader2 = _interopRequireDefault(_PackageHeader);

var _PackageSection = __webpack_require__(168);

var _PackageSection2 = _interopRequireDefault(_PackageSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NOOP = function NOOP() {};

var handleHover = function handleHover(highlightOffer, id) {
  return function () {
    return highlightOffer(id || null);
  };
};

var article = function article(props) {
  return _react2.default.createElement(
    "article",
    { "data-landscape": props.isMapView ? "" : null, className: props.isBookOnline ? "online" : null },
    _react2.default.createElement(_PackageHeader2.default, props),
    _react2.default.createElement(_PackageSection2.default, props),
    _react2.default.createElement(_PackageFooter2.default, props),
    props.isBookOnline && _react2.default.createElement(
      "span",
      { className: "online-tab" },
      _react2.default.createElement("i", { className: "fa fa-li fa-arrow-pointer" }),
      "BOOKABLE ONLINE"
    )
  );
};

var Package = function Package(props) {
  var highlightOffer = props.highlightOffer,
      isMapView = props.isMapView,
      offerId = props.offerId;

  var hover = isMapView ? handleHover : NOOP;

  return _react2.default.createElement(
    "section",
    {
      className: props.isHighlighted ? "highlight" : null,
      id: offerId,
      "data-component": "package-block",
      onMouseEnter: hover(highlightOffer, offerId),
      onMouseLeave: hover(highlightOffer)
    },
    article(props)
  );
};

exports.default = Package;

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _helpers = __webpack_require__(146);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var footerPrice = function footerPrice(props) {
  var footerNotes = props.footerNotes,
      lmd = props.lmd,
      price = props.price;

  var fromText = lmd ? "as low as" : "from";
  var suffix = lmd ? _react2.default.createElement(
    "em",
    null,
    "per person"
  ) : null;

  return _react2.default.createElement(
    "p",
    null,
    footerNotes && _react2.default.createElement(
      "span",
      null,
      footerNotes
    ),
    _react2.default.createElement(
      "em",
      null,
      fromText
    ),
    " ",
    _react2.default.createElement(
      "strong",
      null,
      "\xA3",
      price
    ),
    suffix
  );
};

var flightParam = function flightParam(link, transportation) {
  if (!transportation || !transportation.flights) return "";
  var separator = link.includes("?") ? "&" : "?";
  return separator + "has_flight=true";
};

var PackageFooter = function PackageFooter(props) {
  var link = (0, _helpers.venueLink)(props);
  var ctaLink = "" + link + flightParam(link, props.transportation);
  return _react2.default.createElement(
    "footer",
    { className: "full-width" },
    footerPrice(props),
    !props.isBookOnline && props.fallbackNumber && props.fallbackNumberHref && _react2.default.createElement(
      "a",
      {
        href: "tel:" + props.fallbackNumberHref,
        className: "button button--small button--alt--solid gtm-track-click",
        role: "button",
        "data-gtm-category": "Region Page",
        "data-gtm-action": "CTA",
        "data-gtm-label": "Call"
      },
      _react2.default.createElement("i", { className: "fas fa-phone fa-fw" }),
      _react2.default.createElement(
        "span",
        null,
        " Call ",
        props.fallbackNumber,
        " now "
      )
    ),
    props.isBookOnline && _react2.default.createElement(
      "a",
      {
        className: "button button--online button--strong",
        href: ctaLink + "#offers",
        role: "button",
        onClick: (0, _helpers.handleClick)("More Info Btn", link)
      },
      _react2.default.createElement(
        "span",
        null,
        " SEE ONLINE OFFERS "
      )
    ),
    _react2.default.createElement(
      "a",
      {
        className: "button button--alt button--strong",
        href: ctaLink + "#offers",
        role: "button",
        onClick: (0, _helpers.handleClick)("More Info Btn", link)
      },
      "See More info",
      _react2.default.createElement(
        "span",
        { className: "offscreen" },
        "rmation on ",
        props.venueName
      )
    )
  );
};

exports.default = PackageFooter;

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _PackageFlags = __webpack_require__(166);

var _PackageFlags2 = _interopRequireDefault(_PackageFlags);

var _PackageImage = __webpack_require__(167);

var _PackageImage2 = _interopRequireDefault(_PackageImage);

var _helpers = __webpack_require__(146);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PackageHeader = function PackageHeader(props) {
  var link = (0, _helpers.venueLink)(props);

  return _react2.default.createElement(
    "header",
    { "data-href": link, onClick: (0, _helpers.handleClick)("Image", link) },
    _react2.default.createElement(_PackageFlags2.default, props),
    _react2.default.createElement(_PackageImage2.default, props)
  );
};

exports.default = PackageHeader;

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PackageFlags = function PackageFlags(props) {
  var flags = props.promotions || [];

  return flags.length ? _react2.default.createElement(
    "ul",
    { "data-component": "label-list", className: props.isBookOnline ? "online" : null },
    flags.map(function (flag) {
      var text = flag['name'];
      var type = flag['slug'];
      return _react2.default.createElement(
        "li",
        { key: "flag-" + type, "data-type": type },
        text
      );
    })
  ) : null;
};

exports.default = PackageFlags;

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTACT_US = "https://www.yourgolftravel.com/contact-us";
var LICENSE = "https://creativecommons.org/licenses/by-nc-nd/4.0/";
var TRANS = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
var WIDTH = "720 px";

var meta = function meta(props) {
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement("meta", { content: props.venueName, itemProp: "caption" }),
    _react2.default.createElement("meta", { content: props.venueImageUrlPalmAndUp, itemProp: "contentUrl" }),
    _react2.default.createElement("meta", { content: LICENSE, itemProp: "license" }),
    _react2.default.createElement("meta", { content: CONTACT_US, itemProp: "acquireLicensePage" }),
    _react2.default.createElement("meta", { content: props.venueImageUrlSmallPalm, itemProp: "thumbnailUrl" }),
    _react2.default.createElement("meta", { content: WIDTH, itemProp: "width" })
  );
};

var picture = function picture(props) {
  return _react2.default.createElement(
    "picture",
    { "data-defer": "", itemScope: true, itemType: "https://schema.org/ImageObject" },
    meta(props),
    _react2.default.createElement("source", { media: "(min-width: 801px)", "data-srcset": props.venueImageUrlPalmAndUp }),
    _react2.default.createElement("img", {
      alt: props.venueName,
      decoding: "async",
      height: "1",
      width: "1",
      "data-srcset": props.venueImageUrlSmallPalm,
      "data-type": "package",
      src: TRANS
    })
  );
};

var PackageImage = function PackageImage(props) {
  return _react2.default.createElement(
    "div",
    { "aria-label": props.venueName + " image", role: "img", "data-responsive": "" },
    picture(props)
  );
};

exports.default = PackageImage;

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pluralize = __webpack_require__(31);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _PackageFeatures = __webpack_require__(169);

var _PackageFeatures2 = _interopRequireDefault(_PackageFeatures);

var _helpers = __webpack_require__(146);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var packageTitle = function packageTitle(props) {
  var nights = (0, _pluralize2.default)("Night", props.nights, true);
  var rounds = props.rounds === -1 ? "Unlimited Rounds" : (0, _pluralize2.default)("Round", props.rounds, true);
  var _props$transportation = props.transportation,
      transportation = _props$transportation === undefined ? {} : _props$transportation;

  var title = [];

  if (transportation.eurotunnel) {
    title.push("Le Shuttle");
  }

  if (transportation.flights) {
    title.push("Flights");
  }

  title.push(nights, rounds);

  return title.join(", ");
};

var ratingAndReviewLink = function ratingAndReviewLink(props) {
  var roundedRating = props.venueStarRating.toString().replace(/\.0+$/, "");
  var venueReviewCount = props.venueReviewCount;

  var link = (0, _helpers.venueLink)(props) + "#reviews";

  if (props.lmd) {
    link = link.replace(/last-minute-deals\//, "");
  }

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement("i", { className: "fa fa-star", "aria-hidden": "true" }),
    "Rated ",
    roundedRating,
    " by ",
    (0, _pluralize2.default)("golfer", venueReviewCount, true),
    " ",
    _react2.default.createElement(
      "span",
      null,
      "(",
      _react2.default.createElement(
        "a",
        { href: link, onClick: (0, _helpers.handleClick)("Reviews Link", link) },
        "Read ",
        (0, _pluralize2.default)("review", venueReviewCount),
        _react2.default.createElement(
          "span",
          { className: "offscreen" },
          " of ",
          props.venueName
        )
      ),
      ")"
    )
  );
};

var featuredRatingAndReview = function featuredRatingAndReview(props) {
  return _react2.default.createElement(
    "p",
    { "data-component": "rating-and-review-link" },
    ratingAndReviewLink(props)
  );
};

var packageSectionHeader = function packageSectionHeader(props) {
  return _react2.default.createElement(
    "header",
    null,
    _react2.default.createElement(
      "h3",
      null,
      _react2.default.createElement(
        "a",
        {
          href: (0, _helpers.venueLink)(props),
          onClick: (0, _helpers.handleClick)("Offer Title", (0, _helpers.venueLink)(props))
        },
        props.venueName
      ),
      props.isFeatured && _react2.default.createElement(
        "span",
        { "data-type": "featured" },
        "Featured"
      )
    )
  );
};

var directions = function directions(props) {
  var _ref = props.navigation || {},
      distance = _ref.distance,
      drivingTime = _ref.drivingTime;

  if (distance && distance > 1) {
    return _react2.default.createElement(
      "span",
      null,
      _react2.default.createElement("br", null),
      "(",
      distance,
      " miles away, ",
      drivingTime,
      " drive)"
    );
  }

  return null;
};

var PackageSection = function PackageSection(props) {
  return _react2.default.createElement(
    "section",
    null,
    packageSectionHeader(props),
    _react2.default.createElement(
      "p",
      null,
      props.venueRegionName,
      directions(props)
    ),
    !!props.venueStarRating && featuredRatingAndReview(props),
    _react2.default.createElement(
      "p",
      null,
      packageTitle(props)
    ),
    _react2.default.createElement(_PackageFeatures2.default, props)
  );
};

exports.default = PackageSection;

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pluralize = __webpack_require__(31);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var joiner = function joiner(courses, conjunction) {
  var length = courses.length;

  var lastDelimiter = length < 2 ? "" : conjunction;
  var lastCourse = courses.pop();

  return [courses.join(", "), lastCourse].join(lastDelimiter);
};

var random = function random() {
  return Math.random().toString(36);
};

var roundsListItem = function roundsListItem(roundsText, courses) {
  var key = courses.replace(" ", "-");

  return _react2.default.createElement(
    "li",
    { key: key },
    _react2.default.createElement("i", { className: "fa fa-flag fa-li" }),
    roundsText,
    " at ",
    courses
  );
};

var allocatedRoundsOld = function allocatedRoundsOld(allocated) {
  return allocated.map(function (_ref) {
    var name = _ref.name,
        rounds = _ref.rounds;
    return roundsListItem((0, _pluralize2.default)("round", rounds, true), name);
  });
};

var allocatedRoundsNew = function allocatedRoundsNew(allocated) {
  return allocated.map(function (text) {
    return _react2.default.createElement(
      "li",
      { key: "allocated-" + random() },
      _react2.default.createElement("i", { className: "fa fa-flag fa-li" }),
      text
    );
  });
};

var allocatedRounds = function allocatedRounds(allocated) {
  if (!allocated || !allocated.length) {
    return null;
  }

  if (allocated.some(function (item) {
    return typeof item !== "string";
  })) {
    return allocatedRoundsOld(allocated);
  }

  return allocatedRoundsNew(allocated);
};

var unallocatedRoundsOld = function unallocatedRoundsOld(unallocated) {
  if (!unallocated.rounds) {
    return null;
  }

  var courses = unallocated.courses.map(function (_ref2) {
    var name = _ref2.name;
    return name;
  });
  var roundsText = (0, _pluralize2.default)("round", unallocated.rounds, true);

  return roundsListItem(roundsText, joiner(courses, " or "));
};

var unallocatedRoundsNew = function unallocatedRoundsNew(unallocated) {
  return _react2.default.createElement(
    "li",
    { key: "unallocated" },
    _react2.default.createElement("i", { className: "fa fa-flag fa-li" }),
    unallocated
  );
};

var unallocatedRounds = function unallocatedRounds(unallocated) {
  if (!unallocated) {
    return null;
  }

  if (typeof unallocated !== "string") {
    return unallocatedRoundsOld(unallocated);
  }

  return unallocatedRoundsNew(unallocated);
};

var unlimitedRoundsOld = function unlimitedRoundsOld(unlimited) {
  var courses = unlimited.map(function (_ref3) {
    var name = _ref3.name;
    return name;
  });

  return roundsListItem("Unlimited rounds", joiner(courses, " and "));
};

var unlimitedRoundsNew = function unlimitedRoundsNew(unlimited) {
  return _react2.default.createElement(
    "li",
    { key: "unlimited" },
    _react2.default.createElement("i", { className: "fa fa-flag fa-li" }),
    unlimited
  );
};

var unlimitedRounds = function unlimitedRounds(unlimited) {
  if (!unlimited || !unlimited.length) {
    return null;
  }

  if (typeof unlimited !== "string") {
    return unlimitedRoundsOld(unlimited);
  }

  return unlimitedRoundsNew(unlimited);
};

var flightLineItem = function flightLineItem(transportation) {
  if (!transportation || !transportation.flights) return null;

  var text = transportation.flight_golf_bag_included ? "Flights + Golf Bag" : "Return Flights";
  return _react2.default.createElement(
    "li",
    { key: "flights" },
    _react2.default.createElement("i", { className: "fa fa-plane fa-li" }),
    text
  );
};

var transfersLineItem = function transfersLineItem(transportation) {
  var parts = [];
  if (transportation && transportation.airport_transfers) parts.push("Airport");
  if (transportation && transportation.golf_transfers) parts.push("Golf");
  if (!parts.length) return null;

  return _react2.default.createElement(
    "li",
    { key: "transfers" },
    _react2.default.createElement("i", { className: "fa fa-car fa-li" }),
    "Return ",
    parts.join(" & "),
    " Transfers"
  );
};

var PackageFeatures = function PackageFeatures(props) {
  var boardBasis = props.boardBasis,
      notes = props.notes,
      roundsDetails = props.roundsDetails,
      transportation = props.transportation;

  return _react2.default.createElement(
    "ul",
    { className: "icon-list icon-list--yellow", "data-component": "offer-list" },
    flightLineItem(transportation),
    transfersLineItem(transportation),
    boardBasis && _react2.default.createElement(
      "li",
      null,
      _react2.default.createElement("i", { className: "fa fa-bed fa-li" }),
      boardBasis
    ),
    allocatedRounds(roundsDetails.allocated),
    unallocatedRounds(roundsDetails.unallocated),
    unlimitedRounds(roundsDetails.unlimited),
    notes && notes.map(function (note, index) {
      // eslint-disable-next-line react/no-array-index-key
      return _react2.default.createElement(
        "li",
        { key: "note-" + index },
        _react2.default.createElement("i", { className: "fa fa-check-circle-o fa-li" }),
        note
      );
    })
  );
};

exports.default = PackageFeatures;

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(53);

var _from2 = _interopRequireDefault(_from);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _gtm_tracking = __webpack_require__(5);

var _Enquiries = __webpack_require__(20);

var _Forms = __webpack_require__(26);

var _Forms2 = _interopRequireDefault(_Forms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleEnquiryClick = function handleEnquiryClick(buttonSelector) {
  return function (e) {
    if (e.target.closest(buttonSelector)) {
      $("#js-digital-brochure-request-modal").modal("hide");
      $('#js-digital-brochure-request-modal').on('hidden.bs.modal', function () {
        $("#js-general-enquiry-modal").modal("show");
      });
    }
  };
};

var setFormAttributes = function setFormAttributes(form, data) {
  var brochureType = data.brochureType,
      brochurePath = data.brochurePath,
      gtmCategory = data.gtmCategory,
      gtmAction = data.gtmAction;

  var brochureTypeField = form.querySelector(".js-brochure-type");
  var brochurePathField = form.querySelector(".js-brochure-path");
  var contactLink = form.querySelector(".js-contact-link");
  var downloadButton = form.querySelector(".js-brochure-download-button");

  (0, _assign2.default)(form.dataset, {
    brochurePath: brochurePath,
    brochureType: brochureType,
    gtmCategory: gtmCategory,
    gtmAction: gtmAction
  });

  if (brochureTypeField) {
    brochureTypeField.value = brochureType;
  }

  if (brochurePathField) {
    brochurePathField.value = brochurePath;
  }

  if (contactLink) {
    contactLink.dataset.gtmCategory = data.contactLinkGtmCategory;
  }

  if (downloadButton) {
    (0, _assign2.default)(downloadButton.dataset, {
      gtmCategory: gtmCategory,
      gtmAction: gtmAction,
      gtmLabel: "Brochure"
    });
  }
};

var handleClick = function handleClick(buttonSelector) {
  return function (e) {
    if (!e.target.closest(buttonSelector)) {
      return;
    }

    var data = e.target.dataset;
    var modal = document.querySelector(data.targetModalId);
    var brochureForm = modal ? modal.querySelector(".js-digital-brochure-request-form, .js-print-brochure-request-form") : null;

    if (!modal || !brochureForm) {
      return;
    }

    (0, _Enquiries.setTitle)(brochureForm, data.brochureTitle);
    setFormAttributes(brochureForm, data);

    $(modal).modal("show");
  };
};

var handlePrintBrochureFormSubmit = function handlePrintBrochureFormSubmit(e) {
  e.preventDefault();

  var form = e.target;
  var _form$dataset = form.dataset,
      gtmCategory = _form$dataset.gtmCategory,
      gtmAction = _form$dataset.gtmAction;

  var brochureType = {
    name: "brochure_request[brochure_type]",
    value: form.dataset.brochureType
  };
  var brochure = form.closest(".js-brochure");
  var submit = form.querySelector("button[type='submit']");
  var firstName = form.querySelector("input[name='brochure_request[first_name]']").value;
  var firstNameTitle = firstName.charAt(0).toUpperCase() + firstName.slice(1);

  $.post(form.action, $(form).serializeArray().concat(brochureType)).done(function () {
    (0, _gtm_tracking.gaEventNoHit)(gtmCategory, gtmAction, "Brochure");
    brochure.classList.remove("has-failed");
    brochure.classList.add("has-succeeded");
    form.querySelector(".js-first-name").innerHTML = firstNameTitle;
  }).fail(function () {
    brochure.classList.add("has-failed");
  }).always(function () {
    submit.removeAttribute("disabled");
  });
};

var initPrintBrochureTogglePhoneConsent = function initPrintBrochureTogglePhoneConsent(e) {
  var checkbox = e.querySelector("#brochure_request_phone_opt_in");

  checkbox.addEventListener("click", function () {
    var phoneField = e.querySelector(".js-phone-consent");

    phoneField.querySelector(".js-phone-input").required = this.checked;
    phoneField.classList.toggle("hide");
  });
};

var initBrochureRequestForms = function initBrochureRequestForms() {
  (0, _from2.default)(document.querySelectorAll(".js-print-brochure-request-form")).forEach(function (form) {
    (0, _Forms2.default)(form, { submit: handlePrintBrochureFormSubmit });
  });

  (0, _from2.default)(document.querySelectorAll(".js-brochure")).forEach(function (brochure) {
    return (0, _Enquiries.resetModal)(brochure);
  });

  initPrintBrochureTogglePhoneConsent(document.querySelector(".js-print-brochure-request-form"));
  document.body.addEventListener("click", handleClick(".js-brochure-button"));
  document.body.addEventListener("click", handleEnquiryClick(".js-digital-brochure-enquiry"));
};

exports.default = initBrochureRequestForms;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gtm_tracking = __webpack_require__(5);

var _Enquiries = __webpack_require__(20);

var _Forms = __webpack_require__(26);

var _Forms2 = _interopRequireDefault(_Forms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackAndRedirect = function trackAndRedirect(enquiry) {
  return function () {
    (0, _gtm_tracking.gaEventNoHit)("The Masters Experience", "CTA", "Brochure");
    window.location = enquiry.dataset.redirect || "/";
  };
};

var appendEmailMarketingStatement = function appendEmailMarketingStatement() {
  var _window = window,
      EMAIL_MARKETING_STATEMENT = _window.EMAIL_MARKETING_STATEMENT;


  if (EMAIL_MARKETING_STATEMENT) {
    document.querySelectorAll(".js-email-marketing-statement").forEach(function (container) {
      container.innerHTML += EMAIL_MARKETING_STATEMENT;
    });
  }
};

var initMastersExperienceEnquiry = function initMastersExperienceEnquiry() {
  var enquiry = document.querySelector("#js-masters-experience-enquiry");

  if (enquiry) {
    var form = enquiry.querySelector(".js-enquiry-form");

    if (form) {
      (0, _Forms2.default)(form, {
        submit: (0, _Enquiries.handleSubmit)(enquiry, { done: trackAndRedirect(enquiry) })
      });

      appendEmailMarketingStatement();
    }

    (0, _Enquiries.addInvalidSubmitHandler)(form);
  }
};

exports.default = initMastersExperienceEnquiry;

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(33);
var TAG = __webpack_require__(3)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initEnquiry = exports.initLoadCountryPhone = exports.formFieldFocusHandler = exports.addInvalidSubmitHandler = exports.resetModal = exports.setCallUsText = exports.setAdditionalInfoPlaceholder = exports.setButtonText = exports.setCountryDropdownVisibility = exports.setTitle = exports.setSubtitle = exports.missingOrInvalidField = exports.handleSubmit = undefined;

var _defineProperty2 = __webpack_require__(22);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(7);

var _extends4 = _interopRequireDefault(_extends3);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = __webpack_require__(4);

var _keys2 = _interopRequireDefault(_keys);

var _pluralize = __webpack_require__(31);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _dayjs = __webpack_require__(48);

var _dayjs2 = _interopRequireDefault(_dayjs);

var _emarsys = __webpack_require__(55);

var _emarsys2 = _interopRequireDefault(_emarsys);

var _gtm_tracking = __webpack_require__(5);

var _Forms = __webpack_require__(26);

var _Forms2 = _interopRequireDefault(_Forms);

var _DateFormatConsts = __webpack_require__(52);

var _Patterns = __webpack_require__(49);

var _dropdown_phone_code = __webpack_require__(103);

var _dropdown_phone_code2 = _interopRequireDefault(_dropdown_phone_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var submitBooking = function submitBooking(enquiry, data) {
  var form = enquiry.querySelector(".js-booking-form");

  (0, _keys2.default)(data).forEach(function (key) {
    form.querySelector("input[name=" + key + "]").value = data[key];
  });

  form.submit();
};

var trackRemarketing = function trackRemarketing(slug, price) {
  (0, _gtm_tracking.dynamicRemarketing)({
    hrental_id: slug,
    hrental_totalvalue: parseInt(price, 10),
    hrental_pagetype: "conversion"
  });
};

var toggleSubmitButtons = function toggleSubmitButtons(enquiry, active) {
  var enquireButton = enquiry.querySelector(".js-enquiry-submit");
  var bookButton = enquiry.querySelector(".js-booking-submit");

  if (active) {
    enquireButton.removeAttribute("disabled");

    if (bookButton) {
      bookButton.classList.remove("hide");
    }
  } else {
    enquireButton.setAttribute("disabled", "");

    if (bookButton) {
      bookButton.classList.add("hide");
    }
  }
};

var toggleErrorMessages = function toggleErrorMessages(enquiry, active) {
  if (active) {
    enquiry.classList.add("has-failed");
  } else {
    enquiry.classList.remove("has-failed");
  }
};

var handleError = function handleError(form, className, msgError) {
  var element = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "div";

  var fieldSelector = form.querySelector(className);

  if (fieldSelector) {
    fieldSelector.classList.add("is-invalid");
    fieldSelector = fieldSelector.closest(element);
    fieldSelector.querySelector(".fa-exclamation-triangle").classList.remove("hide");
    var htmlErrors = document.createElement("div");
    htmlErrors.classList.add("error-message", "js-error-message");
    htmlErrors.innerText = msgError;
    fieldSelector.after(htmlErrors);
  }
};

var scrollToElement = function scrollToElement(form, className) {
  var scrollToEl = form.querySelector(className);
  if (scrollToEl) {
    var navOffset = 135;
    var topOfElement = window.pageYOffset + scrollToEl.getBoundingClientRect().top - navOffset;
    window.scroll({ top: topOfElement, behavior: "smooth" });
  }
};

var getErrorMessages = function getErrorMessages(enquiry, res, form) {
  var errorsHandled = 0;
  var resErrors = JSON.parse(res.responseText).errors;

  if (resErrors) {
    var keys = (0, _keys2.default)(resErrors);
    var listFieldNameAndParent = {
      email: ["email address"],
      phone: ["phone number", ".layout__item__field"],
      first_name: ["first name"],
      last_name: ["last name"]
    };

    keys.forEach(function (key) {
      var fieldInfo = listFieldNameAndParent[key];

      if (fieldInfo) {
        var convertedKey = ".js-" + key.replace(/_/g, '-') + "-input";

        handleError(form, convertedKey, "Please enter a valid " + fieldInfo[0], fieldInfo[1]);

        errorsHandled += 1;
      }
    });
  }

  scrollToElement(form, ".js-error-message");

  if (errorsHandled === 0) {
    toggleErrorMessages(enquiry, true);
  }

  toggleSubmitButtons(enquiry, true);
};

var postForm = function postForm(enquiry, form, data, callbacks) {
  return function () {
    var firstName = form.querySelector("input[name='enquiry[first_name]']").value;
    var firstNameTitle = firstName.charAt(0).toUpperCase() + firstName.slice(1);
    var slug = window.location.pathname.split("/")[1];
    var enquiryPrice = enquiry.querySelector(".price");
    var price = enquiryPrice ? enquiryPrice.textContent.slice(1) : null;

    $.post(form.action, data).done(function (res) {
      enquiry.querySelector(".js-first-name").textContent = firstNameTitle;
      enquiry.classList.add("has-succeeded");
      var scrollToEl = form.querySelector(".has-succeeded .enquiry__message--success");
      if (scrollToEl) {
        var navOffset = 150;
        // eslint-disable-next-line no-mixed-operators,max-len
        var topOfElement = window.pageYOffset + scrollToEl.getBoundingClientRect().top - navOffset;
        window.scroll({ top: topOfElement, behavior: "smooth" });
      }

      (0, _gtm_tracking.trackEnquiry)(res.gtm_data, res.lead_value);

      if (res.is_booking && res.payment_data.amount) {
        submitBooking(enquiry, res.payment_data);
      } else {
        (0, _emarsys2.default)(res.emarsys_data);
      }

      if (price && slug === "the-masters") {
        trackRemarketing(slug, price);
      }

      if (callbacks.done) {
        callbacks.done();
      }
    }).fail(function (res) {
      getErrorMessages(enquiry, res, form);
      (0, _gtm_tracking.trackServerSideEnquiryError)(form);
    });
  };
};

var handleSubmit = exports.handleSubmit = function handleSubmit(enquiry) {
  var callbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (e) {
    var form = e.target;
    var formData = $(form).serializeArray();
    e.preventDefault();

    var arrivalDate = formData.find(function (item) {
      return item.name.includes("enquiry[arrival_date]");
    });
    var groupSize = formData.find(function (item) {
      return item.name.includes("enquiry[group_size]");
    });
    var phone = formData.find(function (item) {
      return item.name.includes("enquiry[phone]");
    });
    var isPhoneValid = _Patterns.PHONE_PATTERN.test(phone ? phone.value : "");
    var email = form.querySelector(".js-email-input");
    var isEmailValid = _Patterns.EMAIL_PATTERN.test(email ? email.value : "");
    var firstName = form.querySelector(".js-first-name-input").value;
    var isFirstNameValid = firstName && typeof firstName === 'string';
    var lastName = form.querySelector(".js-last-name-input").value;
    var isLastNameValid = lastName && typeof lastName === 'string';

    if (isPhoneValid && isEmailValid && isLastNameValid && isFirstNameValid && (!groupSize || groupSize.value > "0") && (!arrivalDate || arrivalDate.value.length > 0)) {
      toggleSubmitButtons(enquiry, false);
      toggleErrorMessages(enquiry, false);

      $.getJSON("/csrf-token").done(function (res) {
        return formData.push({ name: res.param, value: res.token });
      }).always(postForm(enquiry, form, formData, callbacks));
    }
  };
};

var missingOrInvalidField = exports.missingOrInvalidField = function missingOrInvalidField(target) {
  var errorPrefix = target.validity.valueMissing ? "Missing" : "Invalid";
  return errorPrefix + " Field: " + target.name;
};

var setSubtitle = exports.setSubtitle = function setSubtitle(enquiry, _ref) {
  var nights = _ref.nights,
      rounds = _ref.rounds,
      date = _ref.date,
      override = _ref.override;

  var subtitle = enquiry.querySelector(".js-enquiry-subtitle");

  if (!subtitle) {
    return;
  }

  if (override) {
    subtitle.textContent = override;

    return;
  }

  var dateObj = (0, _dayjs2.default)(date, _DateFormatConsts.UK_DATE_FORMAT);
  var onDate = dateObj.isValid() ? " on <span class=\"nowrap\">\n        " + dateObj.format(_DateFormatConsts.SUMMARY_DATE_FORMAT_SHORT) + "\n      </span>" : "";
  var nightsAndRounds = { night: nights, round: rounds };
  var subtitleText = (0, _keys2.default)(nightsAndRounds).filter(function (key) {
    return !!nightsAndRounds[key];
  }).map(function (key) {
    return (0, _pluralize2.default)(key, nightsAndRounds[key], true);
  }).join(", ").concat(onDate);

  subtitle.innerHTML = subtitleText;
};

var setTitle = exports.setTitle = function setTitle(enquiry, text) {
  var title = enquiry.querySelector(".js-enquiry-title");
  var dest = enquiry.querySelector(".js-destination");

  if (title && text) {
    title.textContent = text;
  } else if (title && dest) {
    title.textContent = dest.options[dest.selectedIndex].text;
  }
};

var setCountryDropdownVisibility = exports.setCountryDropdownVisibility = function setCountryDropdownVisibility(enquiry, setting) {
  var dropdownElement = enquiry.querySelector(".js-country-dropdown");
  var countrySelect = dropdownElement.querySelector("select");

  if (setting) {
    dropdownElement.style.display = "block";
    countrySelect.removeAttribute("disabled");
  } else {
    dropdownElement.style.display = "none";
    countrySelect.setAttribute("disabled", "disabled");
  }
};

var setButtonText = exports.setButtonText = function setButtonText(enquiry, text) {
  var button = enquiry.querySelector(".js-cta-button");

  if (button && text) {
    button.textContent = text;
  }
};

var setAdditionalInfoPlaceholder = exports.setAdditionalInfoPlaceholder = function setAdditionalInfoPlaceholder(enquiry, placeholder) {
  var textBox = enquiry.querySelector(".js-additional-info");

  if (textBox && placeholder) {
    textBox.placeholder = placeholder;
  }
};

var setCallUsText = exports.setCallUsText = function setCallUsText(enquiry, text) {
  var element = enquiry.querySelector(".js-call-us");

  if (element && text) {
    element.textContent = text;
  }
};

var addErrorMsg = function addErrorMsg(form, msg) {
  var offerSubtitle = form.querySelector(".venue__offer__subtitle");
  var errorMsgTag = form.querySelector(".venue__offer__subtitle-container .js-error-message");
  if (errorMsgTag) {
    errorMsgTag.remove();
  }

  var htmlErrors = document.createElement("div");
  htmlErrors.classList.add("error-message", "js-error-message");
  htmlErrors.innerText = msg;
  offerSubtitle.after(htmlErrors);
};

var handleToggle = function handleToggle(enquiry, toggleSelector) {
  return function (e) {
    if (e.target.closest(toggleSelector)) {
      var date = enquiry.querySelector(".js-arrival-date").value;

      var _map = ["nights", "rounds"].map(function (key) {
        return [].slice.call(enquiry.querySelectorAll(".js-enquiry-" + key)).map(function (node) {
          return node.value;
        }).reduce(function (sum, curr) {
          return sum + parseInt(curr, 10);
        }, 0);
      }),
          _map2 = (0, _slicedToArray3.default)(_map, 2),
          nights = _map2[0],
          rounds = _map2[1];

      e.preventDefault();
      enquiry.classList.toggle("is-shifted");
      enquiry.classList.remove("has-failed");
      setTitle(enquiry);
      setSubtitle(enquiry, { nights: nights, rounds: rounds, date: date });
    }
  };
};

var handleFlightsToggle = function handleFlightsToggle(enquiry, toggleSelector) {
  return function (e) {
    if (e.target.closest(toggleSelector)) {
      enquiry.querySelector(".js-airport-input").classList.toggle("hide", !e.target.checked);
    }
  };
};

var hidePhoneFields = function hidePhoneFields() {
  var phoneFields = document.querySelector(".js-phone-consent");
  if (phoneFields) {
    phoneFields.classList.add("hide");
  }
};

var resetModal = exports.resetModal = function resetModal(enquiry) {
  var modal = enquiry.closest(".modal");

  if (modal) {
    $(modal).on("hidden.bs.modal", function () {
      var enquireButton = enquiry.querySelector(".js-enquiry-submit");
      var bookButton = enquiry.querySelector(".js-booking-submit");
      var defaultCheckedBoxes = enquiry.querySelectorAll(".js-checked-box");
      var defaultUncheckedBoxes = enquiry.querySelectorAll(".js-unchecked-box");

      enquiry.classList.remove("has-failed", "has-succeeded", "is-shifted");
      enquireButton.removeAttribute("disabled");

      defaultCheckedBoxes.forEach(function (checkBox) {
        checkBox.checked = true;
      });
      defaultUncheckedBoxes.forEach(function (checkBox) {
        checkBox.checked = false;
      });
      if (bookButton) bookButton.classList.remove("hide");

      hidePhoneFields();
    });
  }
};

var invalidEnquiryData = function invalidEnquiryData(form) {
  var inputs = [].slice.call(form.getElementsByTagName("input"));
  var formData = inputs.reduce(function (obj, input) {
    return (0, _extends4.default)((0, _defineProperty3.default)({}, input.name, input.value), obj);
  }, {});

  var validationErrors = inputs.filter(function (input) {
    return !input.validity.valid;
  }).map(missingOrInvalidField);

  var breadcrumbs = document.querySelector(".js-breadcrumbs");

  var supplementedFormData = (0, _extends4.default)({}, formData, {
    "enquiry[url]": window.location.href,
    "enquiry[validation_errors]": validationErrors,
    "enquiry[page]": document.title,
    "enquiry[breadcrumbs]": breadcrumbs ? breadcrumbs.innerText : ""
  });

  return supplementedFormData;
};

var validateDate = function validateDate(form) {
  var date = form.querySelector(".js-offer-date");

  return !date || date.value.length > 0; // return true if no date field or field has value
};

var dateFieldValidation = function dateFieldValidation(form) {
  var isDateValid = validateDate(form);

  if (!isDateValid) {
    var container = form.querySelector(".js-offer-date-container");
    if (container) {
      container.classList.add("is-invalid");
    }

    var msgError = 'Please select a date';
    addErrorMsg(form, msgError);
  }
  return isDateValid;
};

var validatePax = function validatePax(form) {
  var pax = form.querySelector(".js-offer-pax");
  var selectedPax = pax ? pax.options[pax.selectedIndex] : 0;
  return !pax || selectedPax.value > 0;
};

var paxFieldValidation = function paxFieldValidation(form) {
  var isPaxValid = validatePax(form);
  if (!isPaxValid) {
    var container = form.querySelector(".js-offer-pax-container");
    if (container) {
      container.classList.add("is-invalid");
    }

    var msgError = 'Select no. of people';
    addErrorMsg(form, msgError);
  }
  return isPaxValid;
};

var removeHtmlTagErrors = function removeHtmlTagErrors(form, className) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "div";

  var selector = form.querySelector(className);

  if (selector) {
    // Remove Html tag errors
    selector.closest(element).querySelectorAll(".js-error-message").forEach(function (e) {
      e.remove();
    });
  }
};

var addInvalidSubmitHandler = exports.addInvalidSubmitHandler = function addInvalidSubmitHandler(form) {
  form.querySelector("[type=submit]").addEventListener("click", function () {
    // Remove tag html errors
    removeHtmlTagErrors(form, ".js-email-input", ".field-group");
    removeHtmlTagErrors(form, ".js-phone-input", ".field-group");
    removeHtmlTagErrors(form, ".js-first-name-input", ".field-group");
    removeHtmlTagErrors(form, ".js-last-name-input", ".field-group");
    removeHtmlTagErrors(form, ".venue__offer__subtitle", ".venue__offer__subtitle-container");

    // Validate first name
    var firstName = form.querySelector(".js-first-name-input");
    firstName = firstName ? firstName.value : "";
    if (firstName === "") {
      handleError(form, ".js-first-name-input", "Please enter a valid first name");
    }

    // Validate last name
    var lastName = form.querySelector(".js-last-name-input");
    lastName = lastName ? lastName.value : "";
    if (lastName === "") {
      handleError(form, ".js-last-name-input", "Please enter a valid last name");
    }

    // Validate email
    var email = form.querySelector(".js-email-input");
    var isEmailValid = _Patterns.EMAIL_PATTERN.test(email ? email.value : "");
    if (!isEmailValid) {
      handleError(form, ".js-email-input", "Please enter a valid email address");
    }

    // Validate phone
    var phone = form.querySelector(".js-phone-input");
    var isPhoneValid = _Patterns.PHONE_PATTERN.test(phone ? phone.value : "");
    if (!isPhoneValid) {
      handleError(form, ".js-phone-input", "Please enter a valid phone number", ".layout__item__field");
    }

    // Validate arrival date
    var isDateValid = dateFieldValidation(form);
    var isPaxValid = paxFieldValidation(form);

    if (!isDateValid && !isPaxValid) {
      var errorMsg = form.querySelector(".js-error-message");
      if (errorMsg) {
        errorMsg.remove();
      }

      var msgError = 'Select no. of people & a date';
      addErrorMsg(form, msgError);
    }
    scrollToElement(form, ".js-error-message");

    scrollToElement(form, ".js-error-message");

    if (isPaxValid && isDateValid && isEmailValid && !form.checkValidity()) {
      var invalidFields = [].slice.call(form.querySelectorAll(":invalid"));
      var phoneFieldValid = !invalidFields.some(function (input) {
        return input.name === "enquiry[phone]";
      });
      var emailFieldValid = !invalidFields.some(function (input) {
        return input.name === "enquiry[email]";
      });

      if (phoneFieldValid || emailFieldValid) {
        var data = (0, _Forms.queryString)(invalidEnquiryData(form));

        fetch("/incomplete_enquiries?" + data, {
          method: "POST"
        });
      }
    }
  });
};

var addDateFocusHandler = function addDateFocusHandler(enquiry) {
  var dateInput = enquiry.querySelector(".js-offer-date");
  if (dateInput) {
    dateInput.addEventListener("focus", function () {
      var dateContainer = enquiry.querySelector(".js-offer-date-container.is-invalid");
      if (dateContainer) {
        dateContainer.classList.remove("is-invalid");
      }
      var errorMsg = enquiry.querySelector(".js-error-message");
      if (errorMsg) {
        errorMsg.remove();
      }
    });
  }
};

var addPaxFocusHandler = function addPaxFocusHandler(enquiry) {
  var paxInput = enquiry.querySelector(".js-offer-pax");
  if (paxInput) {
    paxInput.addEventListener("focus", function () {
      var paxContainer = enquiry.querySelector(".js-offer-pax-container.is-invalid");
      if (paxContainer) {
        paxContainer.classList.remove("is-invalid");
      }
      var errorMsg = enquiry.querySelector(".js-error-message");
      if (errorMsg) {
        errorMsg.remove();
      }
    });
  }
};

var fieldFocusHandler = function fieldFocusHandler(enquiry, className) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "div";

  var fieldFocus = enquiry.querySelector(className);
  if (fieldFocus) {
    fieldFocus.addEventListener("focus", function () {
      var selectorParentTag = fieldFocus;
      selectorParentTag = selectorParentTag.closest(element);

      var warningTag = selectorParentTag.querySelector(".fa-exclamation-triangle");
      if (warningTag) {
        warningTag.classList.add("hide");
      }

      var errorMsgTag = selectorParentTag.querySelector(".js-error-message");
      if (errorMsgTag) {
        errorMsgTag.remove();
      }
    });
  }
};

var formFieldFocusHandler = exports.formFieldFocusHandler = function formFieldFocusHandler(enquiry) {
  fieldFocusHandler(enquiry, ".js-phone-input", ".field-group");

  fieldFocusHandler(enquiry, ".js-email-input", ".field-group");

  fieldFocusHandler(enquiry, ".js-first-name-input", ".field-group");

  fieldFocusHandler(enquiry, ".js-last-name-input", ".field-group");
};

var initLoadCountryPhone = exports.initLoadCountryPhone = function initLoadCountryPhone(enquiry) {
  var containers = enquiry.querySelectorAll(".js-phone-container");
  if (containers) {
    (0, _dropdown_phone_code2.default)(containers);
  }
};

var initEnquiry = exports.initEnquiry = function initEnquiry(enquiry) {
  var form = enquiry.querySelector(".js-enquiry-form");

  resetModal(enquiry);

  (0, _Forms2.default)(form, { submit: handleSubmit(enquiry) });

  enquiry.addEventListener("click", handleToggle(enquiry, ".js-enquiry-toggle"));

  enquiry.addEventListener("change", handleFlightsToggle(enquiry, ".js-flights-toggle"));

  addDateFocusHandler(enquiry);

  addPaxFocusHandler(enquiry);

  formFieldFocusHandler(enquiry);

  addInvalidSubmitHandler(form);

  initLoadCountryPhone(enquiry);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(39);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(23);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(63), __esModule: true };

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(97);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(100);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(4);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(11);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(10);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _pluralize = __webpack_require__(31);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Package = __webpack_require__(163);

var _Package2 = _interopRequireDefault(_Package);

var _fetcher = __webpack_require__(50);

var _ellipsis = __webpack_require__(89);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PackageGenerator = function (_React$Component) {
  (0, _inherits3.default)(PackageGenerator, _React$Component);

  function PackageGenerator() {
    (0, _classCallCheck3.default)(this, PackageGenerator);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PackageGenerator.__proto__ || (0, _getPrototypeOf2.default)(PackageGenerator)).call(this));

    _this.getPackage = function (id) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var queryParams = (0, _keys2.default)(params).map(function (param) {
        return param + "=" + params[param];
      }).join("&");
      var idSlug = id ? "/" + id : "";
      var packagesAPI = "/api/packages" + idSlug + "?" + queryParams;

      (0, _fetcher.json)(packagesAPI).then(function (data) {
        var pkg = data.package || data.packages && data.packages[0];

        if (pkg) {
          _this.setState({ package: pkg, venue: data.venue });
        }
      });
    };

    _this.getCheapestPackage = function () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this.getPackage(null, (0, _extends3.default)({}, params, { cheapest: true }));
    };

    _this.packageTitle = function () {
      var _package = _this.state.package;
      var unlimitedRounds = _package.total_nights === -1;
      var nights = (0, _pluralize2.default)("Night", _package.total_nights, true);
      var rounds = unlimitedRounds ? "Unlimited Rounds" : (0, _pluralize2.default)("Round", _package.total_rounds, true);

      return [nights, rounds].join(", ");
    };

    _this.state = {
      package: null,
      venue: null
    };
    return _this;
  }

  (0, _createClass3.default)(PackageGenerator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          packageId = _props.packageId,
          slug = _props.slug;


      if (packageId) {
        this.getPackage(packageId, { slug: slug });
      } else if (slug) {
        this.getCheapestPackage({ slug: slug });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var state = this.state;

      if (!state.package) {
        return null;
      }
      var pkg = state.package,
          venue = state.venue;


      return _react2.default.createElement(_Package2.default, {
        key: state.venue.slug,
        id: pkg._id,
        name: this.packageTitle(),
        price: pkg.price,
        nights: pkg.total_nights,
        rounds: pkg.total_rounds,
        roundsDetails: pkg.round_allocations,
        boardBasis: pkg.board_basis,
        promotions: pkg.special_offers,
        transportation: pkg.transportation,
        isFeatured: false,
        venueStarRating: venue.rating,
        venueReviewCount: venue.reviews,
        venueName: venue.name,
        venueLat: parseFloat(venue.lat),
        venueLon: parseFloat(venue.lon),
        venueRegionName: venue.place,
        venueImageUrlSmallPalm: venue.images.smallPalm,
        venueImageUrlPalmAndUp: venue.images.palmAndUp,
        venueUrl: venue.slug,
        fallbackNumber: _ellipsis.FALLBACK_NUMBER,
        fallbackNumberHref: _ellipsis.FALLBACK_NUMBER_HREF
      });
    }
  }]);
  return PackageGenerator;
}(_react2.default.Component);

exports.default = PackageGenerator;

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(19);
var ITERATOR = __webpack_require__(3)('iterator');
var Iterators = __webpack_require__(35);
module.exports = __webpack_require__(0).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryString = exports.default = undefined;

var _keys = __webpack_require__(4);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _Patterns = __webpack_require__(49);

var _gtm_tracking = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleBlur = function handleBlur(e) {
  var input = e.target;


  if (input.matches(".js-trim-email")) {
    input.value = input.value.replace(/\s/g, "");
  }
};

var handleFocus = function handleFocus(e) {
  var input = e.target;


  if (input.matches(".form-control")) {
    input.classList.remove("is-invalid");
  }
};

var handleInput = function handleInput(e) {
  var input = e.target;


  if (input.matches(".js-floating-placeholder")) {
    input.parentElement.classList.toggle("has-input", !!input.value);
  }
};

var handleInvalid = function handleInvalid(e) {
  var input = e.target;


  if (input.matches(".form-control")) {
    e.preventDefault();
    input.classList.add("is-invalid");
    (0, _gtm_tracking.trackInvalidEnquiryForm)(input);
  }
};

function initForm(form) {
  var eventHandlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  (function () {
    if (form) {
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      }, false);
    }
  })();

  if (form) {
    var EVENT_HANDLERS = (0, _extends3.default)({
      input: handleInput,
      blur: { handler: handleBlur, useCapture: true },
      invalid: { handler: handleInvalid, useCapture: true },
      focus: { handler: handleFocus, useCapture: true }
    }, eventHandlers);

    (0, _keys2.default)(EVENT_HANDLERS).filter(function (eventName) {
      return EVENT_HANDLERS[eventName];
    }).forEach(function (eventName) {
      var event = EVENT_HANDLERS[eventName];
      var handler = event.handler || event;
      var useCapture = !!event.useCapture;

      form.addEventListener(eventName, handler, useCapture);
    });

    form.querySelectorAll(".js-phone-input").forEach(function (input) {
      input.setAttribute("pattern", _Patterns.PHONE_PATTERN.source);
    });
  }
}

var queryString = function queryString() {
  var formData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _keys2.default)(formData).map(function (key) {
    return key + "=" + encodeURIComponent(formData[key]);
  }).join("&");
};

exports.default = initForm;
exports.queryString = queryString;

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

/* global define */

(function (root, pluralize) {
  /* istanbul ignore else */
  if (true) {
    // Node.
    module.exports = pluralize();
  } else if (typeof define === 'function' && define.amd) {
    // AMD, registers as an anonymous module.
    define(function () {
      return pluralize();
    });
  } else {
    // Browser global.
    root.pluralize = pluralize();
  }
})(this, function () {
  // Rule storage - pluralize and singularize need to be run sequentially,
  // while other rules can be optimized using an object for instant lookups.
  var pluralRules = [];
  var singularRules = [];
  var uncountables = {};
  var irregularPlurals = {};
  var irregularSingles = {};

  /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */
  function sanitizeRule (rule) {
    if (typeof rule === 'string') {
      return new RegExp('^' + rule + '$', 'i');
    }

    return rule;
  }

  /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */
  function restoreCase (word, token) {
    // Tokens are an exact match.
    if (word === token) return token;

    // Lower cased words. E.g. "hello".
    if (word === word.toLowerCase()) return token.toLowerCase();

    // Upper cased words. E.g. "WHISKY".
    if (word === word.toUpperCase()) return token.toUpperCase();

    // Title cased words. E.g. "Title".
    if (word[0] === word[0].toUpperCase()) {
      return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
    }

    // Lower cased words. E.g. "test".
    return token.toLowerCase();
  }

  /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */
  function interpolate (str, args) {
    return str.replace(/\$(\d{1,2})/g, function (match, index) {
      return args[index] || '';
    });
  }

  /**
   * Replace a word using a rule.
   *
   * @param  {string} word
   * @param  {Array}  rule
   * @return {string}
   */
  function replace (word, rule) {
    return word.replace(rule[0], function (match, index) {
      var result = interpolate(rule[1], arguments);

      if (match === '') {
        return restoreCase(word[index - 1], result);
      }

      return restoreCase(match, result);
    });
  }

  /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {string}   token
   * @param  {string}   word
   * @param  {Array}    rules
   * @return {string}
   */
  function sanitizeWord (token, word, rules) {
    // Empty string or doesn't need fixing.
    if (!token.length || uncountables.hasOwnProperty(token)) {
      return word;
    }

    var len = rules.length;

    // Iterate over the sanitization rules and use the first one to match.
    while (len--) {
      var rule = rules[len];

      if (rule[0].test(word)) return replace(word, rule);
    }

    return word;
  }

  /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */
  function replaceWord (replaceMap, keepMap, rules) {
    return function (word) {
      // Get the correct token and case restoration functions.
      var token = word.toLowerCase();

      // Check against the keep object map.
      if (keepMap.hasOwnProperty(token)) {
        return restoreCase(word, token);
      }

      // Check against the replacement map for a direct word replacement.
      if (replaceMap.hasOwnProperty(token)) {
        return restoreCase(word, replaceMap[token]);
      }

      // Run all the rules against the word.
      return sanitizeWord(token, word, rules);
    };
  }

  /**
   * Check if a word is part of the map.
   */
  function checkWord (replaceMap, keepMap, rules, bool) {
    return function (word) {
      var token = word.toLowerCase();

      if (keepMap.hasOwnProperty(token)) return true;
      if (replaceMap.hasOwnProperty(token)) return false;

      return sanitizeWord(token, token, rules) === token;
    };
  }

  /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {string}  word      The word to pluralize
   * @param  {number}  count     How many of the word exist
   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
   * @return {string}
   */
  function pluralize (word, count, inclusive) {
    var pluralized = count === 1
      ? pluralize.singular(word) : pluralize.plural(word);

    return (inclusive ? count + ' ' : '') + pluralized;
  }

  /**
   * Pluralize a word.
   *
   * @type {Function}
   */
  pluralize.plural = replaceWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Check if a word is plural.
   *
   * @type {Function}
   */
  pluralize.isPlural = checkWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Singularize a word.
   *
   * @type {Function}
   */
  pluralize.singular = replaceWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Check if a word is singular.
   *
   * @type {Function}
   */
  pluralize.isSingular = checkWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addPluralRule = function (rule, replacement) {
    pluralRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addSingularRule = function (rule, replacement) {
    singularRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */
  pluralize.addUncountableRule = function (word) {
    if (typeof word === 'string') {
      uncountables[word.toLowerCase()] = true;
      return;
    }

    // Set singular and plural references for the word.
    pluralize.addPluralRule(word, '$0');
    pluralize.addSingularRule(word, '$0');
  };

  /**
   * Add an irregular word definition.
   *
   * @param {string} single
   * @param {string} plural
   */
  pluralize.addIrregularRule = function (single, plural) {
    plural = plural.toLowerCase();
    single = single.toLowerCase();

    irregularSingles[single] = plural;
    irregularPlurals[plural] = single;
  };

  /**
   * Irregular rules.
   */
  [
    // Pronouns.
    ['I', 'we'],
    ['me', 'us'],
    ['he', 'they'],
    ['she', 'they'],
    ['them', 'them'],
    ['myself', 'ourselves'],
    ['yourself', 'yourselves'],
    ['itself', 'themselves'],
    ['herself', 'themselves'],
    ['himself', 'themselves'],
    ['themself', 'themselves'],
    ['is', 'are'],
    ['was', 'were'],
    ['has', 'have'],
    ['this', 'these'],
    ['that', 'those'],
    // Words ending in with a consonant and `o`.
    ['echo', 'echoes'],
    ['dingo', 'dingoes'],
    ['volcano', 'volcanoes'],
    ['tornado', 'tornadoes'],
    ['torpedo', 'torpedoes'],
    // Ends with `us`.
    ['genus', 'genera'],
    ['viscus', 'viscera'],
    // Ends with `ma`.
    ['stigma', 'stigmata'],
    ['stoma', 'stomata'],
    ['dogma', 'dogmata'],
    ['lemma', 'lemmata'],
    ['schema', 'schemata'],
    ['anathema', 'anathemata'],
    // Other irregular rules.
    ['ox', 'oxen'],
    ['axe', 'axes'],
    ['die', 'dice'],
    ['yes', 'yeses'],
    ['foot', 'feet'],
    ['eave', 'eaves'],
    ['goose', 'geese'],
    ['tooth', 'teeth'],
    ['quiz', 'quizzes'],
    ['human', 'humans'],
    ['proof', 'proofs'],
    ['carve', 'carves'],
    ['valve', 'valves'],
    ['looey', 'looies'],
    ['thief', 'thieves'],
    ['groove', 'grooves'],
    ['pickaxe', 'pickaxes'],
    ['passerby', 'passersby']
  ].forEach(function (rule) {
    return pluralize.addIrregularRule(rule[0], rule[1]);
  });

  /**
   * Pluralization rules.
   */
  [
    [/s?$/i, 's'],
    [/[^\u0000-\u007F]$/i, '$0'],
    [/([^aeiou]ese)$/i, '$1'],
    [/(ax|test)is$/i, '$1es'],
    [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, '$1es'],
    [/(e[mn]u)s?$/i, '$1s'],
    [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, '$1'],
    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
    [/(seraph|cherub)(?:im)?$/i, '$1im'],
    [/(her|at|gr)o$/i, '$1oes'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
    [/sis$/i, 'ses'],
    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
    [/([^aeiouy]|qu)y$/i, '$1ies'],
    [/([^ch][ieo][ln])ey$/i, '$1ies'],
    [/(x|ch|ss|sh|zz)$/i, '$1es'],
    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
    [/\b((?:tit)?m|l)(?:ice|ouse)$/i, '$1ice'],
    [/(pe)(?:rson|ople)$/i, '$1ople'],
    [/(child)(?:ren)?$/i, '$1ren'],
    [/eaux$/i, '$0'],
    [/m[ae]n$/i, 'men'],
    ['thou', 'you']
  ].forEach(function (rule) {
    return pluralize.addPluralRule(rule[0], rule[1]);
  });

  /**
   * Singularization rules.
   */
  [
    [/s$/i, ''],
    [/(ss)$/i, '$1'],
    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
    [/ies$/i, 'y'],
    [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'],
    [/\b(mon|smil)ies$/i, '$1ey'],
    [/\b((?:tit)?m|l)ice$/i, '$1ouse'],
    [/(seraph|cherub)im$/i, '$1'],
    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, '$1'],
    [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, '$1sis'],
    [/(movie|twelve|abuse|e[mn]u)s$/i, '$1'],
    [/(test)(?:is|es)$/i, '$1is'],
    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
    [/(alumn|alg|vertebr)ae$/i, '$1a'],
    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
    [/(matr|append)ices$/i, '$1ix'],
    [/(pe)(rson|ople)$/i, '$1rson'],
    [/(child)ren$/i, '$1'],
    [/(eau)x?$/i, '$1'],
    [/men$/i, 'man']
  ].forEach(function (rule) {
    return pluralize.addSingularRule(rule[0], rule[1]);
  });

  /**
   * Uncountable rules.
   */
  [
    // Singular words with no plurals.
    'adulthood',
    'advice',
    'agenda',
    'aid',
    'aircraft',
    'alcohol',
    'ammo',
    'analytics',
    'anime',
    'athletics',
    'audio',
    'bison',
    'blood',
    'bream',
    'buffalo',
    'butter',
    'carp',
    'cash',
    'chassis',
    'chess',
    'clothing',
    'cod',
    'commerce',
    'cooperation',
    'corps',
    'debris',
    'diabetes',
    'digestion',
    'elk',
    'energy',
    'equipment',
    'excretion',
    'expertise',
    'firmware',
    'flounder',
    'fun',
    'gallows',
    'garbage',
    'graffiti',
    'hardware',
    'headquarters',
    'health',
    'herpes',
    'highjinks',
    'homework',
    'housework',
    'information',
    'jeans',
    'justice',
    'kudos',
    'labour',
    'literature',
    'machinery',
    'mackerel',
    'mail',
    'media',
    'mews',
    'moose',
    'music',
    'mud',
    'manga',
    'news',
    'only',
    'personnel',
    'pike',
    'plankton',
    'pliers',
    'police',
    'pollution',
    'premises',
    'rain',
    'research',
    'rice',
    'salmon',
    'scissors',
    'series',
    'sewage',
    'shambles',
    'shrimp',
    'software',
    'species',
    'staff',
    'swine',
    'tennis',
    'traffic',
    'transportation',
    'trout',
    'tuna',
    'wealth',
    'welfare',
    'whiting',
    'wildebeest',
    'wildlife',
    'you',
    /pok[eé]mon$/i,
    // Regexes.
    /[^aeiou]ese$/i, // "chinese", "japanese"
    /deer$/i, // "deer", "reindeer"
    /fish$/i, // "fish", "blowfish", "angelfish"
    /measles$/i,
    /o[iu]s$/i, // "carnivorous"
    /pox$/i, // "chickpox", "smallpox"
    /sheep$/i
  ].forEach(pluralize.addUncountableRule);

  return pluralize;
});


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getEnvironment() {
  var meta = document.querySelector('meta[name="server-environment"]');

  return meta ? meta.getAttribute("content") : undefined;
}

var isDataSaving = function isDataSaving() {
  return document.documentElement.hasAttribute("data-save-data");
};

var isDevelopment = function isDevelopment() {
  return getEnvironment() === 'development';
};

var isProduction = function isProduction() {
  return !isDevelopment();
};

var isStaging = function isStaging() {
  return getEnvironment() === 'staging';
};

exports.getEnvironment = getEnvironment;
exports.isDataSaving = isDataSaving;
exports.isDevelopment = isDevelopment;
exports.isProduction = isProduction;
exports.isStaging = isStaging;

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(116);


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(65);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _browser = __webpack_require__(157);

var _environment = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDev = (0, _environment.isDevelopment)();

function checkArraylikeObject(obj, values) {
  [].slice.call(obj).every(function (value, index) {
    return value === values[index];
  });
}

function logger(notice) {
  if (isDev || (0, _environment.isStaging)()) {
    // eslint-disable-next-line
    console.warn('Airbrake notice', notice);
  }
}

var FILTERS = [function (notice) {
  var block = isDev;

  (0, _assign2.default)(notice.context, {
    environment: (0, _environment.getEnvironment)(),
    os: navigator.platform
  });

  logger(notice);

  return block ? null : notice;
}, function (notice) {
  var block = notice.errors.some(function (error) {
    return (/Blocked a frame with origin/.test(error.message)
    );
  });

  logger(notice);

  return block ? null : notice;
}, function (notice) {
  var params = notice.params;

  var block = false;

  if (params) {
    block = checkArraylikeObject(params, ['dispatchEvent', 'cross-origin']);
    logger(notice);
  }

  return block ? null : notice;
}, function (notice) {
  // add more strings as necessary
  var items = ['_AutofillCallbackHandler', "(reading 'style')", "Can't find variable: gmo"];
  var block = notice.errors.some(function (error) {
    return items.some(function (item) {
      return error.message.indexOf(item) !== -1;
    });
  });

  logger(notice);

  return block ? null : notice;
}];

var PROJECT_ID = 80953;
var PROJECT_KEY = '413697d851828380dc389bef0911549e';

var notifier = new _browser.Notifier({ projectId: PROJECT_ID, projectKey: PROJECT_KEY });

FILTERS.forEach(function (filter) {
  notifier.addFilter(filter);
});

exports.default = notifier;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(80), __esModule: true };

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(8);
var aFunction = __webpack_require__(39);
var SPECIES = __webpack_require__(3)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(14);
var invoke = __webpack_require__(71);
var html = __webpack_require__(144);
var cel = __webpack_require__(141);
var global = __webpack_require__(6);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(33)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var isObject = __webpack_require__(32);
var newPromiseCapability = __webpack_require__(21);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(8);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(35);
var ITERATOR = __webpack_require__(3)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(3)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line
var EMAIL_PATTERN = exports.EMAIL_PATTERN = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

var NOISEWORDS_PATTERN = exports.NOISEWORDS_PATTERN = /\b(a(?:nd?|t)?|but|from|[io][fn]|[fn]?or|t(?:h(?:e|is)))\b/ig;

// eslint-disable-next-line
var PHONE_PATTERN = exports.PHONE_PATTERN = /^(?=\D*(?:\d\D*){7,}$)(?:([\d\s+\(\)\-])(?!\1{6,}))+$/;

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEWS = exports.EVENT_TYPES = exports.DEFAULT_CONSENT = exports.virtualPageView = exports.trackServerSideEnquiryError = exports.trackLastMinuteDeal = exports.trackInvalidEnquiryForm = exports.trackGoal = exports.trackEnquiry = exports.trackClick = exports.pushDataLayer = exports.ga4Event = exports.gaEventNoHit = exports.gaEvent = exports.dynamicRemarketing = undefined;

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _Enquiries = __webpack_require__(20);

var _ga4_helper = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toSnakeCase = function toSnakeCase(string) {
  return string.replace(/([A-Z]+)/g, "_$1").replace(/^_/, "");
};

var VIEWS = {
  PERSONAL_DETAILS: ["Enquiry, Personal Details", "/enquiries/personal_details"],
  TRAVEL_DETAILS: ["Enquiry, Travel Details", "/enquiries/travel_details"],
  ENQUIRY_COMPLETE: ["Enquiry, Completed", "/enquiries/completed"],
  BOOKING_CUSTOMIZE_OFFER: ["Customize Offer", "/booking/customize-offer"],
  BOOKING_PERSONAL_DETAILS: ["Personal Details", "/booking/personal-details"],
  BOOKING_STRIPE_CHECKOUT: ["Stripe Checkout", "/booking/checkout"],
  BOOKING_COMPLETE: ["Booking Complete", "/booking/complete"]
};

var DEFAULT_CONSENT = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied'
};

var EVENT_TYPES = {
  DYNAMIC_REMARKETING: 'dynamicRemarketing',
  GA: 'GAEvent',
  GA_NO_HIT: 'GAEventNoHit',
  GA4: 'GA4Event',
  GA4_NO_HIT: 'GA4EventNoHit',
  VIRTUAL_PAGEVIEW: 'VirtualPageview'
};

var GOALS = {
  CLICKED_PACKAGE: ["Search Page", "Clicked Package"],
  CLICKED_DYNAMIC_PACKAGE: ["Dynamic Page", "Clicked Package"],
  VIEWED_DYNAMIC: ["Dynamic Page View", "Success"],
  VIEWED_REGION: ["Region View", "Success"],
  VIEWED_VENUE: ["Venue View", "Success"]
};

var COMMON_METRICS = ["goal", "ecommerce", "remarketing"];

var hasMarketingConsent = function hasMarketingConsent() {
  return window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.marketing;
};

var lastVisibilityChange = void 0;

var pushDataLayer = function pushDataLayer(payload) {
  if (!payload) {
    return;
  }

  window.dataLayer.push(payload);
};

var pushGAEvent = function pushGAEvent(event, payload) {
  if (!payload.eventCategory || !payload.eventAction) {
    return;
  }

  pushDataLayer((0, _extends3.default)({ event: event }, payload));
};

var dynamicRemarketing = function dynamicRemarketing(remarketingData) {
  if (hasMarketingConsent()) {
    pushDataLayer({ event: EVENT_TYPES.DYNAMIC_REMARKETING, remarketingData: remarketingData });
  }
};

var trackCommonMetrics = function trackCommonMetrics(data) {
  var commonMetrics = hasMarketingConsent() ? COMMON_METRICS : COMMON_METRICS.filter(function (metric) {
    return metric !== "remarketing";
  });

  commonMetrics.forEach(function (metric) {
    return pushDataLayer(data[metric]);
  });
};

var gaEvent = function gaEvent(eventCategory, eventAction, eventLabel) {
  pushGAEvent(EVENT_TYPES.GA, { eventCategory: eventCategory, eventAction: eventAction, eventLabel: eventLabel });
  pushGAEvent(EVENT_TYPES.GA4, { eventCategory: eventCategory, eventAction: eventAction, eventLabel: eventLabel });
};

var gaEventNoHit = function gaEventNoHit(eventCategory, eventAction, eventLabel) {
  pushGAEvent(EVENT_TYPES.GA_NO_HIT, { eventCategory: eventCategory, eventAction: eventAction, eventLabel: eventLabel });
  pushGAEvent(EVENT_TYPES.GA4_NO_HIT, { eventCategory: eventCategory, eventAction: eventAction, eventLabel: eventLabel });
};

var ga4Event = function ga4Event(eventCategory, eventAction, eventLabel) {
  pushGAEvent(EVENT_TYPES.GA4, { eventCategory: eventCategory, eventAction: eventAction, eventLabel: eventLabel });
};

var virtualPageView = function virtualPageView(pageView) {
  var view = VIEWS[pageView] || VIEWS[toSnakeCase(pageView).toUpperCase()];
  var event = EVENT_TYPES.VIRTUAL_PAGEVIEW;

  if (!view) {
    throw new ReferenceError(event + ": \"" + pageView + "\" not found");
  }

  var _view = (0, _slicedToArray3.default)(view, 2),
      virtualPageTitle = _view[0],
      virtualPageURL = _view[1];

  pushDataLayer({ event: event, virtualPageTitle: virtualPageTitle, virtualPageURL: virtualPageURL });
};

var trackGoal = function trackGoal(goalName) {
  var goal = GOALS[goalName];

  if (!goal) {
    return;
  }

  var _goal = (0, _slicedToArray3.default)(goal, 2),
      action = _goal[0],
      label = _goal[1];

  gaEvent("Goals", action, label);
};

var trackEnquiry = function trackEnquiry(gtmData, leadValue) {
  trackCommonMetrics(gtmData);
  virtualPageView("ENQUIRY_COMPLETE");
  (0, _ga4_helper.pushGa4Event)({
    event: "generate_lead",
    lead_type: "Enquiry",
    lead_value: leadValue
  });
};

var trackLastMinuteDeal = function trackLastMinuteDeal(data) {
  trackCommonMetrics(data);
  virtualPageView("BOOKING_COMPLETE");
};

var trackClick = function trackClick(target) {
  var _target$dataset = target.dataset,
      gtmCategory = _target$dataset.gtmCategory,
      gtmAction = _target$dataset.gtmAction,
      gtmLabel = _target$dataset.gtmLabel,
      gtmPageview = _target$dataset.gtmPageview;


  if (gtmCategory) {
    gaEvent(gtmCategory, gtmAction, gtmLabel || target.href);
  }

  if (gtmPageview) {
    virtualPageView(gtmPageview);
  }
};

var trackInvalidEnquiryForm = function trackInvalidEnquiryForm(target) {
  var formType = target.form.dataset.gtmFormType || "Enquiry Form";

  gaEventNoHit("Failed Enquiry", formType, (0, _Enquiries.missingOrInvalidField)(target));
};

var trackServerSideEnquiryError = function trackServerSideEnquiryError(target) {
  var trackedError = "Failed enquiry: 422 error";
  var formType = target.dataset.gtmFormType || "Enquiry Form";

  gaEventNoHit("Failed Enquiry", formType, trackedError);
};

var trackVisibilityState = function trackVisibilityState() {
  var now = new Date().getTime();
  var _window = window,
      dataLayer = _window.dataLayer;

  var state = document.visibilityState;

  if (!lastVisibilityChange) {
    var GTM_START = "gtm.start";
    var start = dataLayer.find(function (entry) {
      return entry && entry[GTM_START];
    });

    lastVisibilityChange = start ? start[GTM_START] : now - 1;
  } else {
    state = state === "hidden" ? "visible" : "hidden";
  }

  var diff = now - lastVisibilityChange;

  if (diff) {
    pushGAEvent(EVENT_TYPES.GA_NO_HIT, {
      eventCategory: "Page Visibility",
      eventAction: state,
      eventLabel: location.pathname,
      eventValue: diff
    });
  }

  lastVisibilityChange = now;
};

var trackTotalVisibility = function trackTotalVisibility(visible) {
  var eventAction = visible ? "visible" : "hidden";
  var eventCategory = "Total Page " + (visible ? "Visibility" : "Invisibility");
  var total = window.dataLayer.filter(Boolean).filter(function (entry) {
    return entry.eventCategory === "Page Visibility" && entry.eventAction === eventAction;
  }).reduce(function (acc, entry) {
    return acc + entry.eventValue;
  }, 0);

  pushGAEvent(EVENT_TYPES.GA_NO_HIT, {
    eventCategory: eventCategory,
    eventAction: "Page Unload",
    eventLabel: location.pathname,
    eventValue: Math.min(total, 30 * 60 * 1e3)
  });
};

window.dataLayer = window.dataLayer || [];

window.addEventListener("load", trackVisibilityState);
window.addEventListener("beforeunload", function () {
  trackVisibilityState();
  trackTotalVisibility(true);
  trackTotalVisibility();
});

document.addEventListener("visibilitychange", trackVisibilityState);

exports.dynamicRemarketing = dynamicRemarketing;
exports.gaEvent = gaEvent;
exports.gaEventNoHit = gaEventNoHit;
exports.ga4Event = ga4Event;
exports.pushDataLayer = pushDataLayer;
exports.trackClick = trackClick;
exports.trackEnquiry = trackEnquiry;
exports.trackGoal = trackGoal;
exports.trackInvalidEnquiryForm = trackInvalidEnquiryForm;
exports.trackLastMinuteDeal = trackLastMinuteDeal;
exports.trackServerSideEnquiryError = trackServerSideEnquiryError;
exports.virtualPageView = virtualPageView;
exports.DEFAULT_CONSENT = DEFAULT_CONSENT;
exports.EVENT_TYPES = EVENT_TYPES;
exports.VIEWS = VIEWS;

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.json = exports.fetcher = exports.dispatchProgressEvent = undefined;

var _regenerator = __webpack_require__(36);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(104);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _asyncToGenerator2 = __webpack_require__(37);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var fetcher = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(url) {
    var fetchOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var abortController, _fetchOptions$headers, headers, timeout, rest, options, headerOptions, controller, response, length, err;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            abortController = fetchOptions.abortController, _fetchOptions$headers = fetchOptions.headers, headers = _fetchOptions$headers === undefined ? {} : _fetchOptions$headers, timeout = fetchOptions.timeout, rest = (0, _objectWithoutProperties3.default)(fetchOptions, ["abortController", "headers", "timeout"]);
            options = (0, _extends3.default)({}, _constants.FETCHOPTIONS, rest);
            headerOptions = (0, _extends3.default)({}, _constants.FETCHOPTIONS.headers, headers);


            options.headers = headerOptions;

            controller = abortController;
            response = void 0;


            dispatchProgressEvent(_constants.PROGRESSEVENT_TYPES.LOADSTART);

            if (controller || timeout) {
              controller = controller || new AbortController();
              options.signal = controller.signal;

              if (timeout) {
                setTimeout(function () {
                  controller.abort();
                  dispatchProgressEvent(_constants.PROGRESSEVENT_TYPES.TIMEOUT);
                }, timeout);
              }
            }

            _context.prev = 8;
            _context.next = 11;
            return fetch(url, options);

          case 11:
            response = _context.sent;

            if (response.ok) {
              _context.next = 14;
              break;
            }

            throw new ErrorObject({ message: response.status + " (" + response.statusText.trim() + ")", url: url });

          case 14:
            length = parseInt(response.headers.get("Content-Length"), 10) || 0;


            dispatchProgressEvent(_constants.PROGRESSEVENT_TYPES.LOAD, length);

            return _context.abrupt("return", response);

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](8);

            if (!(_context.t0.name !== "AbortError")) {
              _context.next = 26;
              break;
            }

            dispatchProgressEvent(_constants.PROGRESSEVENT_TYPES.ERROR);
            err = new ErrorObject((0, _extends3.default)({}, _context.t0, { url: url }));


            _airbrake2.default.notify((0, _extends3.default)({}, err, { message: _context.t0.message + " " + url }));

            throw err;

          case 26:

            dispatchProgressEvent(_constants.PROGRESSEVENT_TYPES.ABORT);

            return _context.abrupt("return", null);

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[8, 19]]);
  }));

  return function fetcher(_x4) {
    return _ref.apply(this, arguments);
  };
}();

var json = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { warn: false };
    var abortController, signal, timeout, response;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            abortController = options.abortController, signal = options.signal, timeout = options.timeout;
            _context2.prev = 1;
            _context2.next = 4;
            return fetcher(url, {
              abortController: abortController || new AbortController(),
              headers: {
                Accept: _constants.JSON_CONTENTTYPE + "," + _constants.JS_CONTENTTYPE + ";q=0.8,*/*;q=0.01",
                "Content-Type": _constants.JSON_CONTENTTYPE
              },
              signal: signal,
              timeout: timeout
            });

          case 4:
            response = _context2.sent;
            _context2.next = 7;
            return response.json();

          case 7:
            return _context2.abrupt("return", _context2.sent);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);

            if (options.warn) {
              // eslint-disable-next-line
              console.warn("Data error: " + _context2.t0.message, _context2.t0.url);
            }

            throw _context2.t0;

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[1, 10]]);
  }));

  return function json(_x6) {
    return _ref2.apply(this, arguments);
  };
}();

var _constants = __webpack_require__(59);

var _airbrake = __webpack_require__(38);

var _airbrake2 = _interopRequireDefault(_airbrake);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function dispatchProgressEvent(type) {
  var contentLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var progressEvent = new ProgressEvent(type, {
    lengthComputable: !!contentLength,
    loaded: contentLength,
    total: contentLength
  });

  document.body.dispatchEvent(progressEvent);
}

function ErrorObject() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _assign2.default)({
    timestamp: Date.now()
  }, args);
}

exports.dispatchProgressEvent = dispatchProgressEvent;
exports.fetcher = fetcher;
exports.json = json;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONFIG = {
  // attributes: true,
  childList: true,
  subtree: true
};
var NODE_ELEMENT = 1;
var OBSERVER_ID = "YGT_MutationObserver";
var mutations = {};
/** @type {string[]} */
var mutationsKeys = [];

/**
 * Explicitly destroys the observer.
 */
function destroy() {
  var mutationObserver = window[OBSERVER_ID];

  if (mutationObserver) {
    delete window[OBSERVER_ID];

    mutationObserver.takeRecords();
    mutationObserver.disconnect();
    mutationObserver = null;
  }
}

/**
 * Runs the stack of methods assigned to the node.
 *
 * Each method instantiation is contained within a `requestAnimationFrame` call
 * to reduce the immediacy that otherwise might block the main thread unnecessarily.
 *
 * @param {Node} node The mutated node.
 */
function process(node) {
  mutationsKeys.forEach(function (selector) {
    var methods = mutations[selector] || [];

    if (methods.length === 0) {
      return;
    }

    node.querySelectorAll(selector).forEach(function (element) {
      methods.forEach(function (method) {
        window.requestAnimationFrame(function () {
          method(element);
        });
      });
    });
  });
}

/**
 * Processes the provided mutations collection.
 *
 * @param {MutationRecord[]} entries The collection of mutations.
 */
function onmutation(entries) {
  entries.forEach(function (_ref) {
    var addedNodes = _ref.addedNodes;

    [].slice.call(addedNodes).filter(function (_ref2) {
      var nodeType = _ref2.nodeType;
      return nodeType === NODE_ELEMENT;
    }).forEach(process);
  });
}

/**
 * Adds a new MutationObserver and a pointer on the `window` object.
 *
 * This is run every time `add` is called and sets up the singleton observer.
 */
function init() {
  if (!window[OBSERVER_ID]) {
    var mutationObserver = new MutationObserver(onmutation);

    mutationObserver.observe(document.body, CONFIG);
    window[OBSERVER_ID] = mutationObserver;

    window.addEventListener("beforeunload", destroy);
  }
}

/**
 * Adds a reference via `selector` to run a specified method.
 *
 * @param {string} selector The selector for the relevant node(s).
 * @param {function} callback The method to add to the stack.
 *
 * @example
 * // Logs source of an image when dynamically added
 * add("img", function (img) { console.log(img.src); });
 */
function add(selector, callback) {
  var processes = mutations[selector] || [];

  if (!processes.length) {
    mutationsKeys.push(selector);
  }

  processes.push(callback);
  mutations[selector] = processes;
  init();
}

/**
 * Removes a reference via `selector` to run a specified method.
 *
 * If `callback` is not specified, the entire stack referenced by `selector` is removed.
 *
 * @param {string} selector The selector for the relevant node(s).
 * @param {function} [callback] The method to remove from the stack (optional).
 */
function remove(selector, callback) {
  var processes = (mutations[selector] || []).filter(function (item) {
    return item !== callback;
  });

  if (processes.length) {
    mutations[selector] = processes;
  } else {
    delete mutations[selector];
    mutationsKeys = mutationsKeys.filter(function (key) {
      return key !== selector;
    });
  }
}

/**
 * Return API
 *
 * @example
 * import mutations from "./mutations";
 *
 * const selector = "img";
 * const method = (img) => { console.log(img.src); };
 *
 * mutations.add(selector, method);
 */
exports.default = {
  add: add,
  destroy: destroy,
  remove: remove
};

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(91), __esModule: true };

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(2);
var core = __webpack_require__(0);
var fails = __webpack_require__(62);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsCookie = __webpack_require__(17);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _environment = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.ScarabQueue = window.ScarabQueue || [];

function emarsys() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!(0, _environment.isProduction)() && !(0, _environment.isStaging)()) {
    ScarabQueue.push(['testMode']);
  }

  var category = data.category,
      purchase = data.purchase,
      view = data.view;

  var cart = data.cart || _jsCookie2.default.getJSON('emarsysCartData') || [];
  var inThirtyMinutes = 1 / 48;

  _jsCookie2.default.set('emarsysCartData', cart, {
    expires: inThirtyMinutes,
    samesite: "lax"
  });

  if (view) {
    ScarabQueue.push(['view', view]);
  }

  if (category) {
    ScarabQueue.push(['category', category]);
  }

  if (purchase) {
    _jsCookie2.default.remove('emarsysCartData');
    ScarabQueue.push(['cart', []]);
    ScarabQueue.push(['purchase', purchase]);
  } else {
    ScarabQueue.push(['cart', _jsCookie2.default.getJSON('emarsysCartData')]);
  }

  ScarabQueue.push(['go']);
}

exports.default = emarsys;

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushGa4Event = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pushGa4Event = function pushGa4Event(event) {
  var payload = (0, _extends3.default)({}, event, {
    event_type: "GA4Event"
  });
  window.dataLayer = window.dataLayer || [];

  if (payload.ecommerce) window.dataLayer.push({ ecommerce: null }); // Recommended per docs
  window.dataLayer.push(payload);

  // Nullify `event_type` to prevent recursive merge issues on successive data layer
  // pushes from other sources. E.g. a third-party push to the data layer could
  // inadvertently trigger GA4 tags in GTM if this param is still present.
  window.dataLayer.push({ event_type: null });
};

exports.pushGa4Event = pushGa4Event;

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(155);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _brochure = __webpack_require__(174);

var _brochure2 = _interopRequireDefault(_brochure);

var _masters_experience_enquiry = __webpack_require__(175);

var _masters_experience_enquiry2 = _interopRequireDefault(_masters_experience_enquiry);

var _PackageGenerator = __webpack_require__(243);

var _PackageGenerator2 = _interopRequireDefault(_PackageGenerator);

var _Emarsys = __webpack_require__(87);

var _Emarsys2 = _interopRequireDefault(_Emarsys);

var _map_loader = __webpack_require__(153);

var _map_loader2 = _interopRequireDefault(_map_loader);

var _userTiming = __webpack_require__(118);

var _userTiming2 = _interopRequireDefault(_userTiming);

var _AutocompleteToggle = __webpack_require__(119);

var _AutocompleteToggle2 = _interopRequireDefault(_AutocompleteToggle);

var _video = __webpack_require__(120);

var _video2 = _interopRequireDefault(_video);

var _general_enquiry = __webpack_require__(121);

var _general_enquiry2 = _interopRequireDefault(_general_enquiry);

var _named_enquiry = __webpack_require__(123);

var _named_enquiry2 = _interopRequireDefault(_named_enquiry);

var _scrollspy = __webpack_require__(145);

var _scrollspy2 = _interopRequireDefault(_scrollspy);

var _Newsletter = __webpack_require__(124);

var _Newsletter2 = _interopRequireDefault(_Newsletter);

var _Popover = __webpack_require__(111);

var _Popover2 = _interopRequireDefault(_Popover);

var _airbrake = __webpack_require__(38);

var _airbrake2 = _interopRequireDefault(_airbrake);

var _ellipsis = __webpack_require__(89);

var _ellipsis2 = _interopRequireDefault(_ellipsis);

var _emarsys = __webpack_require__(55);

var _emarsys2 = _interopRequireDefault(_emarsys);

var _gtm_tracking = __webpack_require__(5);

__webpack_require__(60);

__webpack_require__(131);

__webpack_require__(132);

__webpack_require__(90);

__webpack_require__(133);

__webpack_require__(565);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// end from common.js

var userTiming = new _userTiming2.default({ src: "staticPages" });

// from common.js


// from common.js
function handleClickTracking() {
  document.addEventListener("click", function (e) {
    var target = e.target.closest(".gtm-track-click");

    if (target) {
      (0, _gtm_tracking.trackClick)(target);
    }
  });
}
// end from common.js

var renderPackages = function renderPackages() {
  document.querySelectorAll(".package-box").forEach(function (node) {
    _reactDom2.default.render(_react2.default.createElement(_PackageGenerator2.default, {
      packageId: node.dataset.packageId,
      slug: node.dataset.slug
    }), node);
  });
};

function onDOMContentLoaded() {
  userTiming.start("onDOMContentLoaded");

  userTiming.start("common");
  // from common.js
  (0, _AutocompleteToggle2.default)();
  (0, _general_enquiry2.default)();
  (0, _named_enquiry2.default)();
  handleClickTracking();
  (0, _ellipsis2.default)();
  (0, _video2.default)();
  (0, _Newsletter2.default)();
  (0, _Popover2.default)();
  (0, _scrollspy2.default)();

  // end from common.js
  userTiming.finish("common");

  renderPackages();
  (0, _masters_experience_enquiry2.default)();
  (0, _brochure2.default)();
  (0, _map_loader2.default)();
  (0, _Emarsys2.default)();

  userTiming.finish("onDOMContentLoaded");
}

document.addEventListener("DOMContentLoaded", onDOMContentLoaded);

// from common.js
window.addEventListener("error", function (error) {
  _airbrake2.default.notify({ error: error });
});

(0, _emarsys2.default)(window.emarsysData);
// end from common.js

userTiming.finish();

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHARSET = "charset=utf-8";
var JS_CONTENTTYPE = "text/javascript";
var JSON_CONTENTTYPE = "application/json";
var TEXT_CONTENTTYPE = "text/plain";

var FETCHOPTIONS = {
  credentials: "same-origin",
  headers: {},
  mode: "cors",
  redirect: "error",
  referrerPolicy: "no-referrer",
  signal: null
};

var PROGRESSEVENT_TYPES = {
  ABORT: "abort",
  ERROR: "error",
  LOAD: "load",
  LOADSTART: "loadstart",
  PROGRESS: "progress",
  TIMEOUT: "timeout"
};

var RESULTEVENT_TYPES = {
  AUTOCOMPLETE: "autocomplete",
  GOOGLEPLACE: "googleplace",
  SEARCH: "search"
};

var URLS = {
  autocomplete: "/api/autocomplete",
  baseUrl: location.origin, // "https://www.yourgolftravel.com",
  googlePlace: "/api/google_places",
  health: "/api/health",
  search: "/api/search"
};

exports.CHARSET = CHARSET;
exports.FETCHOPTIONS = FETCHOPTIONS;
exports.JS_CONTENTTYPE = JS_CONTENTTYPE;
exports.JSON_CONTENTTYPE = JSON_CONTENTTYPE;
exports.PROGRESSEVENT_TYPES = PROGRESSEVENT_TYPES;
exports.RESULTEVENT_TYPES = RESULTEVENT_TYPES;
exports.TEXT_CONTENTTYPE = TEXT_CONTENTTYPE;
exports.URLS = URLS;

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_EVENT = exports.AFTER_LOAD_EVENT = undefined;

var _environment = __webpack_require__(34);

var _mutations = __webpack_require__(51);

var _mutations2 = _interopRequireDefault(_mutations);

var _airbrake = __webpack_require__(38);

var _airbrake2 = _interopRequireDefault(_airbrake);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AFTER_LOAD_EVENT = "afterload";
var ATTRIBUTE = "data-defer";
var ERROR_EVENT = "error";
var INTERSECTION_CONFIG = {
  root: null,
  rootMargin: "150% 0px",
  threshold: 0
};
var LOAD_EVENT = "load";
var SELECTOR = "picture[" + ATTRIBUTE + "]";
var TRANS = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

var supportsLoading = "loading" in HTMLImageElement.prototype && false;

var intersectionObserver = void 0;

function notify(_ref) {
  var message = _ref.message,
      type = _ref.type;

  _airbrake2.default.notify({
    error: {
      message: message,
      type: type
    }
  });
}

function isImageApplied(target) {
  if ('error' in target.dataset) {
    var srcset = target.srcset;

    var message = srcset;

    if (!srcset || srcset === TRANS) {
      message = (!srcset ? "<not set>" : "<transparent>") + " alt=\"" + target.alt + "\"";
    }

    notify({
      message: "Image load error: " + message,
      type: "LoadError"
    });
  }

  return (
    // the load errored
    'error' in target.dataset ||
    // we only ever wanted TRANS anyway
    target.srcset === TRANS || target instanceof HTMLImageElement && target.src === TRANS ||
    // currentSrc has changed
    target.currentSrc !== TRANS
  );
}

function observeNode(node) {
  intersectionObserver.observe(node);
}

function onimageload(_ref2) {
  var target = _ref2.target;

  if (isImageApplied(target)) {
    target.removeEventListener(LOAD_EVENT, onimageload);
    if (target.picture) {
      target.picture.removeAttribute(ATTRIBUTE);
    } else {
      notify({
        message: "Picture reference lost: alt=\"" + target.alt + "\"",
        type: "PictureError"
      });
    }

    target.removeAttribute("loading");
    var dataset = target.dataset;


    target.alt = dataset.alt;
    delete dataset.alt;

    window.dispatchEvent(new CustomEvent(AFTER_LOAD_EVENT, {
      detail: { src: target }
    }));
  }

  // Additional: report to Airbrake if PictureBox image is being used
  if (/\/pb\//.test(target.srcset)) {
    notify({
      message: "Picturebox image used: " + target.srcset,
      type: "ImageError"
    });
  }
}

function onimageerror(_ref3) {
  var target = _ref3.target;

  target.dataset.error = "";

  var picture = target.picture;


  picture.querySelectorAll("source").forEach(function (source) {
    picture.removeChild(source);
  });
  target.dispatchEvent(new Event(LOAD_EVENT));
}

function processSrcset(element) {
  var dataset = element.dataset;
  var srcset = dataset.srcset;


  if (srcset.substr(0, 2) === "//") {
    // protocol agnostic, fix to HTTPS
    dataset.srcset = "https:" + srcset;
  }

  element.srcset = dataset.srcset;
  delete dataset.srcset;
}

function processImage(target, immediate) {
  var img = target.querySelector("img");
  var _img$fetchPriority = img.fetchPriority,
      fetchPriority = _img$fetchPriority === undefined ? "auto" : _img$fetchPriority;


  img.dataset.alt = img.alt;
  img.alt = "";
  img.picture = target; // memoise to avoid multiple `.closest` calls
  img.addEventListener(ERROR_EVENT, onimageerror, { once: true });
  img.addEventListener(LOAD_EVENT, onimageload);
  img.loading = immediate ? "eager" : "lazy"; // if supported use loading attribute value
  if (fetchPriority === "auto" && immediate) {
    img.fetchPriority = "high";
  }
}

function processDataSaving(srcsets) {
  var result = [];

  if (srcsets.length) {
    var last = srcsets.pop();

    srcsets.forEach(function (srcset) {
      srcset.parentNode.removeChild(srcset);
    });

    if (last.src === TRANS) {
      result = [last];
    }
  }

  return result;
}

function processEntry(target) {
  var immediate = target.dataset.immediate;

  var srcsets = target.querySelectorAll("[data-srcset]");

  if ((0, _environment.isDataSaving)()) {
    srcsets = processDataSaving([].slice.call(srcsets));
  }

  processImage(target, immediate);
  srcsets.forEach(processSrcset);
  if (!supportsLoading) {
    intersectionObserver.unobserve(target);
  }
}

function processNodes(nodes) {
  if (supportsLoading) {
    nodes.forEach(processEntry);
  } else {
    nodes.forEach(observeNode);
  }
}

function processNode(node) {
  var origin = node.parentNode || node;
  var deferred = [].slice.call(origin.querySelectorAll(SELECTOR));

  if (origin.dataset.defer) {
    deferred.unshift(origin);
  }

  if (deferred.length) {
    processNodes(deferred);
  }
}

function onintersection(entries) {
  entries.filter(function (entry) {
    return entry.isIntersecting;
  }).forEach(function (_ref4) {
    var target = _ref4.target;

    processEntry(target);
  });
}

function force(container) {
  if (container) {
    container.querySelectorAll(SELECTOR).forEach(function (element) {
      element.dataset.immediate = true;
      window.requestAnimationFrame(function () {
        processEntry(element);
      });
    });
  }
}

function init() {
  processNodes(document.querySelectorAll(SELECTOR));
}

if (!supportsLoading) {
  intersectionObserver = new IntersectionObserver(onintersection, INTERSECTION_CONFIG);
}

document.addEventListener("DOMContentLoaded", init);

_mutations2.default.add(SELECTOR, processNode);

exports.default = force;
exports.AFTER_LOAD_EVENT = AFTER_LOAD_EVENT;
exports.LOAD_EVENT = LOAD_EVENT;

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(30), 'Object', { defineProperty: __webpack_require__(29).f });


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(67), __esModule: true };

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(139);
__webpack_require__(27);
__webpack_require__(47);
__webpack_require__(68);
__webpack_require__(76);
__webpack_require__(77);
module.exports = __webpack_require__(0).Promise;


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(136);
var global = __webpack_require__(6);
var ctx = __webpack_require__(14);
var classof = __webpack_require__(19);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(32);
var aFunction = __webpack_require__(39);
var anInstance = __webpack_require__(69);
var forOf = __webpack_require__(70);
var speciesConstructor = __webpack_require__(40);
var task = __webpack_require__(41).set;
var microtask = __webpack_require__(72)();
var newPromiseCapabilityModule = __webpack_require__(21);
var perform = __webpack_require__(42);
var userAgent = __webpack_require__(73);
var promiseResolve = __webpack_require__(43);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(3)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(74)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(138)($Promise, PROMISE);
__webpack_require__(75)(PROMISE);
Wrapper = __webpack_require__(0)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(46)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ 69:
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(14);
var call = __webpack_require__(44);
var isArrayIter = __webpack_require__(45);
var anObject = __webpack_require__(8);
var toLength = __webpack_require__(66);
var getIterFn = __webpack_require__(25);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ 71:
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var macrotask = __webpack_require__(41).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(33)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(135);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var core = __webpack_require__(0);
var dP = __webpack_require__(29);
var DESCRIPTORS = __webpack_require__(30);
var SPECIES = __webpack_require__(3)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(2);
var core = __webpack_require__(0);
var global = __webpack_require__(6);
var speciesConstructor = __webpack_require__(40);
var promiseResolve = __webpack_require__(43);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(2);
var newPromiseCapability = __webpack_require__(21);
var perform = __webpack_require__(42);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(83), __esModule: true };

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _breakpoints = __webpack_require__(122);

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasMatchMedia = typeof window.matchMedia === "function";

var screenMaxWidth = function screenMaxWidth(breakpoint) {
  return hasMatchMedia && window.matchMedia("screen and (max-width: " + breakpoint + "px)").matches;
};

var screenMinWidth = function screenMinWidth(breakpoint) {
  return hasMatchMedia && window.matchMedia("screen and (min-width: " + (breakpoint + 1) + "px)").matches;
};

var windowSize = {
  isSmallPalm: function isSmallPalm() {
    return screenMaxWidth(_breakpoints2.default.smallPalm);
  },

  isPalm: function isPalm() {
    return screenMinWidth(_breakpoints2.default.smallPalm) && screenMaxWidth(_breakpoints2.default.mobile);
  },

  isMobile: function isMobile() {
    return screenMaxWidth(_breakpoints2.default.mobile);
  },

  isTab: function isTab() {
    return screenMinWidth(_breakpoints2.default.mobile) && screenMaxWidth(_breakpoints2.default.handheld);
  },

  isHandheld: function isHandheld() {
    return screenMaxWidth(_breakpoints2.default.handheld);
  },

  isLap: function isLap() {
    return screenMinWidth(_breakpoints2.default.handheld) && screenMaxWidth(_breakpoints2.default.portable);
  },

  isDesk: function isDesk() {
    return screenMinWidth(_breakpoints2.default.portable);
  },

  isMaxWidth: function isMaxWidth(width) {
    return screenMaxWidth(width);
  }
};

exports.default = windowSize;

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(81);
module.exports = __webpack_require__(0).Object.keys;


/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(28);
var $keys = __webpack_require__(61);

__webpack_require__(54)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _keys = __webpack_require__(4);

var _keys2 = _interopRequireDefault(_keys);

var _dayjs = __webpack_require__(48);

var _dayjs2 = _interopRequireDefault(_dayjs);

var _gtm_tracking = __webpack_require__(5);

var _window_size = __webpack_require__(79);

var _window_size2 = _interopRequireDefault(_window_size);

var _DateFormatConsts = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  regularPickerOptions: function regularPickerOptions(container) {
    var changeHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    var $container = $(container);

    return {
      container: $container.length && $container || undefined,
      weekdaysShort: ["S", "M", "T", "W", "T", "F", "S"],
      format: _DateFormatConsts.PICKADATE_UK_DATE_FORMAT,
      today: false,
      close: "Cancel",
      firstDay: true,
      min: 1,
      onSet: function onSet(eventOptions) {
        if ("clear" in eventOptions || "select" in eventOptions) {
          var date = (0, _dayjs2.default)(this.get(), _DateFormatConsts.UK_DATE_FORMAT);

          changeHandler(date.isValid() ? date : null);
          if (_window_size2.default.isHandheld()) {
            var offersCount = document.getElementById("js-offers-count");

            if (offersCount) {
              offersCount.scrollIntoView();
            }
          }
        }
      }
    };
  },
  pricedPickerOptions: function pricedPickerOptions(id, changeHandler, pricingData) {
    var dateContainer = document.querySelector("[data-id=\"" + id + "\"] .js-offer-date-container");

    return {
      klass: { picker: "picker picker--priced" },
      weekdaysShort: ["S", "M", "T", "W", "T", "F", "S"],
      format: _DateFormatConsts.PICKADATE_UK_DATE_FORMAT,
      today: false,
      clear: false,
      close: "Cancel",
      container: ".js-pickadate-container-" + id,
      firstDay: true,
      min: 1,
      disable: [true].concat((0, _keys2.default)(pricingData.day_prices).map(function (date) {
        return new Date(date);
      })),
      onOpen: function onOpen() {
        (0, _gtm_tracking.gaEvent)("Venue Page", "Package", "Change Date");
        dateContainer.classList.add("is-open");
      },
      onClose: function onClose() {
        setTimeout(function () {
          dateContainer.classList.remove("is-open");
        }, 500);
      },
      onStart: function onStart() {
        this.component.updatePricingData(pricingData);
      },
      onSet: function onSet(eventOptions) {
        if ("select" in eventOptions) {
          var date = (0, _dayjs2.default)(this.get(), _DateFormatConsts.UK_DATE_FORMAT);

          changeHandler(date.isValid() ? date : null, this.component);
        }
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(84);
module.exports = __webpack_require__(0).Object.setPrototypeOf;


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(85).set });


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(32);
var anObject = __webpack_require__(8);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(14)(Function.call, __webpack_require__(150).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)))

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(22);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(7);

var _extends4 = _interopRequireDefault(_extends3);

var _Emarsys = __webpack_require__(114);

var _Forms = __webpack_require__(26);

var _Forms2 = _interopRequireDefault(_Forms);

var _Recaptcha = __webpack_require__(115);

var _Recaptcha2 = _interopRequireDefault(_Recaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function messageMarkup(message, icon) {
  var text = document.createTextNode(message).textContent;
  var icons = "fa fa-before fa-" + icon;

  return "\n    <p class=\"h4\">\n      <i class=\"" + icons + "\"></i> " + text + "\n    </p>\n  ";
}

var onFail = function onFail(form) {
  return function () {
    var message = form.dataset.failMessage || _Emarsys.FAIL_MESSAGE;

    form.innerHTML = messageMarkup(message, "exclamation-circle");
  };
};

var onSuccess = function onSuccess(form) {
  return function () {
    var message = form.dataset.successMessage || _Emarsys.SUCCESS_MESSAGE;

    form.innerHTML = messageMarkup(message, "check-circle-o");
  };
};

function submitEmarsysForm(form, _ref) {
  var _ref$success = _ref.success,
      _success = _ref$success === undefined ? onSuccess(form) : _ref$success,
      _ref$fail = _ref.fail,
      fail = _ref$fail === undefined ? onFail(form) : _ref$fail;

  var campaignId = form.dataset.campaignId;

  var inputs = [].slice.call(form.getElementsByTagName("input"));
  var nameValuePairs = function nameValuePairs(obj, input) {
    return (0, _extends4.default)((0, _defineProperty3.default)({}, input.name, input.value), obj);
  };
  var formParams = inputs.reduce(nameValuePairs, {});
  var qs = (0, _Forms.queryString)((0, _extends4.default)({}, _Emarsys.PARAMS, formParams, { f: campaignId }));

  (0, _Recaptcha2.default)({
    success: function success() {
      return fetch(_Emarsys.API + "?" + qs, { mode: "no-cors" }).then(_success).catch(fail);
    },
    fail: fail
  });
}

function isFormValid(form) {
  return form && form.dataset.campaignId;
}

function initEmarsysForm() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.querySelector("form[data-emarsys-form]");
  var eventHandlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!isFormValid(form)) {
    return;
  }

  (0, _Forms2.default)(form, eventHandlers);

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    submitEmarsysForm(form, callbacks);
  });
}

exports.default = initEmarsysForm;

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FALLBACK_NUMBER_HREF = exports.FALLBACK_NUMBER = undefined;

var _jsCookie = __webpack_require__(17);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FALLBACK_NUMBER = "0800 043 6644";
var FALLBACK_NUMBER_HREF = "+448000436644";

function ellipsis() {
  var _window = window,
      Ellipsis = _window.Ellipsis;


  if (Ellipsis) {
    Ellipsis.setFallbackNumber(FALLBACK_NUMBER);

    var dataset = document.getElementsByName('ellipsis_metadata')[0].dataset;

    var ellipsisMetadata = window.ellipsisMetadata || {};

    ellipsisMetadata.area = dataset.country;

    // temporary 20% release of Ellipsis GA-tracked session numbers
    var cookieName = "_ellipsis_release_group";
    var releaseRatio = 0.5;
    var releaseGroup = _jsCookie2.default.get(cookieName);

    if (!releaseGroup) {
      releaseGroup = Math.random() <= releaseRatio;
      _jsCookie2.default.set(cookieName, String(releaseGroup), { samesite: "lax" });
    }
  } else {
    document.querySelectorAll(".js-ellipsis").forEach(function (el) {
      el.innerHTML = FALLBACK_NUMBER;
    });
  }
}

exports.default = ellipsis;
exports.FALLBACK_NUMBER = FALLBACK_NUMBER;
exports.FALLBACK_NUMBER_HREF = FALLBACK_NUMBER_HREF;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27);
__webpack_require__(92);
module.exports = __webpack_require__(0).Array.from;


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(14);
var $export = __webpack_require__(2);
var toObject = __webpack_require__(28);
var call = __webpack_require__(44);
var isArrayIter = __webpack_require__(45);
var toLength = __webpack_require__(66);
var createProperty = __webpack_require__(93);
var getIterFn = __webpack_require__(25);

$export($export.S + $export.F * !__webpack_require__(46)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(29);
var createDesc = __webpack_require__(142);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95);
module.exports = __webpack_require__(0).Object.assign;


/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(96) });


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(61);
var gOPS = __webpack_require__(149);
var pIE = __webpack_require__(137);
var toObject = __webpack_require__(28);
var IObject = __webpack_require__(152);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(62)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(98), __esModule: true };

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47);
__webpack_require__(27);
module.exports = __webpack_require__(99);


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(19);
var ITERATOR = __webpack_require__(3)('iterator');
var Iterators = __webpack_require__(35);
module.exports = __webpack_require__(0).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ })

},[564]);


// WEBPACK FOOTER //
// static_pages.01d698e9afba9fef3798.js